// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/home/bg-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./resource/font/DMSans-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./resource/font/DMSans-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./resource/font/DMSans-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./resource/font/DMSans-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./resource/font/DMSans-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./resource/font/DMSans-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./resource/font/DMSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./resource/font/DMSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./resource/font/DMSans-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./resource/font/DMSans-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./resource/font/DMSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./resource/font/DMSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./resource/font/DMSans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./resource/font/DMSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
  :root {
    --white: #fff;
    --light-gray: #fbfbfd;
    --light-gray-2: #f8f8f8;
    --primary: hsla(202, 44%, 28%, 1);
    --primary-text: var(--primary);
    --secondary: hsla(351, 53%, 45%, 1);
    --primary-foreground: #fff;
    --addition-1: hsla(238, 30%, 22%, 1);
    --addition-2: hsla(211, 67%, 42%, 1);
    --addition-3: hsla(205, 58%, 44%, 1);
    --addition-4: hsla(189, 100%, 41%, 1);
    --addition-5: hsla(184, 100%, 36%, 1);
    --addition-6: hsla(184, 41%, 66%, 1);
    --radius: 6px;
    --border: hsla(202, 44%, 28%, 0.1);
    --input: hsla(202, 44%, 28%, 0.1);
    --ring: hsla(184, 100%, 36%, 1);
    --input-bg: hsla(202, 44%, 28%, 0.07);
    --secondary-button: hsla(202, 44%, 28%, 0.15);
    --label: hsla(202, 44%, 28%, 0.7);
    --muted: hsla(210, 16%, 89%, 1);
    --muted-foreground: hsla(202, 44%, 28%, 0.5);
    --destructive: #e0425b;
    /** Status colors: */
    --running: hsla(35, 82%, 51%, 1);
    --done: hsla(169, 86%, 44%, 1);
    --earlyDrop: hsla(202, 79%, 51%, 1);
    --late: hsla(238, 30%, 22%, 0.6);
    --pending: hsla(187, 62%, 47%, 1);
    --approved: hsla(191, 57%, 51%, 1);
    --scheduled: hsla(40, 100%, 50%, 1);
    --sent: hsla(198, 62%, 47%, 1);
    --completed: hsla(169, 86%, 44%, 1);
    --draft: hsla(351, 72%, 57%, 1);
    --active: hsla(169, 86%, 44%, 1);
    --inactive: hsla(351, 72%, 57%, 1);
    --delivered: hsla(202, 79%, 51%, 1);
    --background: hsla(220, 33%, 99%, 1);
    /*--success: 144, 79%, 62%;*/
    /*--background: 0 0% 100%;*/
    /*--foreground: 240 10% 3.9%;*/
    /*--card: 0 0% 100%;*/
    /*--card-foreground: 240 10% 3.9%;*/
    --popover: hsla(0, 0%, 100%);
    --popover-foreground: hsla(240, 10%, 3.9%);
    /*--primary: hsla(211, 67%, 42%, 1);*/
    /*--primary-foreground: 0 0% 98%;*/
    /*--secondary: 240 4.8% 95.9%;*/
    /*--secondary-foreground: 240 5.9% 10%;*/
    /*--muted: 240 4.8% 95.9%;*/
    /*--muted-foreground: 240 3.8% 46.1%;*/
    /*--accent: 240 4.8% 95.9%;*/
    /*--accent-foreground: 240 5.9% 10%;*/
    /*--destructive: #E74A4A;*/
    /*--destructive-foreground: #e16363;*/
    /*--border: 240 5.9% 90%;*/
    /*--input: 240 5.9% 90%;*/
    /*--ring: 240 5.9% 10%;*/
    /*--radius: 0.3rem;*/
    --font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  .home {
    --primary: hsla(215, 33%, 35%, 1);
  }
  .guidance {
    --white: #fff;
    --primary: hsla(201, 95%, 66%, 1);
    --primary-text: var(--addition-1);
    --secondary: hsla(238, 30%, 22%, 1);
    --secondary-2: hsla(215, 32%, 70%, 1);
    --primary-foreground: #f8f9fd;
    --addition-1: hsla(238, 30%, 22%, 1);
    --addition-2: hsla(215, 33%, 35%, 1);
    --addition-3: hsla(243, 91%, 36%, 1);
    --addition-4: hsla(53, 56%, 54%, 1);
    --addition-5: hsla(123, 38%, 45%, 1);
    --addition-6: hsla(237, 100%, 63%, 1);
    --addition-7: hsla(238, 91%, 70%, 1);
    --addition-8: hsla(0, 61%, 45%, 1);
    --addition-9: hsla(15, 100%, 67%, 1);
    --addition-10: hsla(263, 86%, 65%, 1);
    --addition-11: hsla(0, 0%, 13%, 1);
    --radius: 6px;
    --border: hsla(238, 30%, 22%, 0.1);
    --input: hsla(202, 44%, 28%, 0.1);
    --ring: hsla(184, 100%, 36%, 1);
    --input-bg: hsla(202, 44%, 28%, 0.07);
    --label: hsla(202, 44%, 28%, 0.7);
    --muted: rgba(135, 148, 172, 1);
    --muted-foreground: hsla(202, 44%, 28%, 0.5);
    --destructive: hsla(357, 100%, 66%, 1);
    --background: hsla(220, 33%, 99%, 1);
  }
  * {
  border-color: hsla(202, 44%, 28%, 0.1);
  border-color: var(--border);
}
  body {
  background-color: hsla(220, 33%, 99%, 1);
  background-color: var(--background);
  color: var(--foreground);
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 480px) {

  .container {
    max-width: 480px;
  }
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1366px) {

  .container {
    max-width: 1366px;
  }
}
@media (min-width: 2560px) {

  .container {
    max-width: 2560px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: -webkit-sticky;
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.-bottom-0 {
  bottom: -0px;
}
.-bottom-12 {
  bottom: -3rem;
}
.-left-12 {
  left: -3rem;
}
.-right-12 {
  right: -3rem;
}
.-top-12 {
  top: -3rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-\\[10px\\] {
  bottom: 10px;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-64 {
  left: 16rem;
}
.left-\\[10px\\] {
  left: 10px;
}
.left-\\[12px\\] {
  left: 12px;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.left-auto {
  left: auto;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-8 {
  right: 2rem;
}
.right-\\[-30px\\] {
  right: -30px;
}
.right-\\[10px\\] {
  right: 10px;
}
.right-\\[5px\\] {
  right: 5px;
}
.right-\\[8px\\] {
  right: 8px;
}
.right-auto {
  right: auto;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-14 {
  top: 3.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-32 {
  top: 8rem;
}
.top-36 {
  top: 9rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[-30px\\] {
  top: -30px;
}
.top-\\[0px\\] {
  top: 0px;
}
.top-\\[10px\\] {
  top: 10px;
}
.top-\\[40px\\] {
  top: 40px;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[5px\\] {
  top: 5px;
}
.top-\\[6px\\] {
  top: 6px;
}
.top-\\[number\\] {
  top: number;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[10\\] {
  z-index: 10;
}
.z-\\[50\\] {
  z-index: 50;
}
.z-\\[5\\] {
  z-index: 5;
}
.z-\\[60\\] {
  z-index: 60;
}
.col-start-2 {
  grid-column-start: 2;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-0 {
  margin: 0px;
}
.m-\\[-7px\\] {
  margin: -7px;
}
.m-auto {
  margin: auto;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[10px\\] {
  margin-left: 10px;
  margin-right: 10px;
}
.mx-\\[20px\\] {
  margin-left: 20px;
  margin-right: 20px;
}
.mx-\\[40px\\] {
  margin-left: 40px;
  margin-right: 40px;
}
.mx-\\[5px\\] {
  margin-left: 5px;
  margin-right: 5px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-\\[100px\\] {
  margin-top: 100px;
  margin-bottom: 100px;
}
.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}
.my-\\[20px\\] {
  margin-top: 20px;
  margin-bottom: 20px;
}
.\\!mt-0 {
  margin-top: 0px !important;
}
.\\!mt-4 {
  margin-top: 1rem !important;
}
.\\!mt-\\[10px\\] {
  margin-top: 10px !important;
}
.-ml-4 {
  margin-left: -1rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[13px\\] {
  margin-bottom: 13px;
}
.mb-\\[15px\\] {
  margin-bottom: 15px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[25px\\] {
  margin-bottom: 25px;
}
.mb-\\[2px\\] {
  margin-bottom: 2px;
}
.mb-\\[30px\\] {
  margin-bottom: 30px;
}
.mb-\\[50px\\] {
  margin-bottom: 50px;
}
.mb-\\[5px\\] {
  margin-bottom: 5px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-32 {
  margin-left: 8rem;
}
.ml-\\[10px\\] {
  margin-left: 10px;
}
.ml-\\[15px\\] {
  margin-left: 15px;
}
.ml-\\[20px\\] {
  margin-left: 20px;
}
.ml-\\[5px\\] {
  margin-left: 5px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-\\[10px\\] {
  margin-right: 10px;
}
.mr-\\[20px\\] {
  margin-right: 20px;
}
.mr-\\[3px\\] {
  margin-right: 3px;
}
.mr-\\[5px\\] {
  margin-right: 5px;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-\\[-4px\\] {
  margin-top: -4px;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[12px\\] {
  margin-top: 12px;
}
.mt-\\[13px\\] {
  margin-top: 13px;
}
.mt-\\[15px\\] {
  margin-top: 15px;
}
.mt-\\[17px\\] {
  margin-top: 17px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[25px\\] {
  margin-top: 25px;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[50px\\] {
  margin-top: 50px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-\\[8px\\] {
  margin-top: 8px;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.size-\\[15px\\] {
  width: 15px;
  height: 15px;
}
.size-\\[20px\\] {
  width: 20px;
  height: 20px;
}
.size-\\[24px\\] {
  width: 24px;
  height: 24px;
}
.size-\\[34px\\] {
  width: 34px;
  height: 34px;
}
.\\!h-\\[20px\\] {
  height: 20px !important;
}
.\\!h-\\[28px\\] {
  height: 28px !important;
}
.\\!h-\\[35px\\] {
  height: 35px !important;
}
.h-0 {
  height: 0px;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-56 {
  height: 14rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[12px\\] {
  height: 12px;
}
.h-\\[130px\\] {
  height: 130px;
}
.h-\\[13px\\] {
  height: 13px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[17px\\] {
  height: 17px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[19px\\] {
  height: 19px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[23px\\] {
  height: 23px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[254px\\] {
  height: 254px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[275px\\] {
  height: 275px;
}
.h-\\[27px\\] {
  height: 27px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[33px\\] {
  height: 33px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[37px\\] {
  height: 37px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[390px\\] {
  height: 390px;
}
.h-\\[39px\\] {
  height: 39px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[54px\\] {
  height: 54px;
}
.h-\\[56px\\] {
  height: 56px;
}
.h-\\[5px\\] {
  height: 5px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[87vh\\] {
  height: 87vh;
}
.h-\\[8px\\] {
  height: 8px;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-\\[calc\\(100vh-150px\\)\\] {
  height: calc(100vh - 150px);
}
.h-\\[calc\\(100vh-64px-58px-48px\\)\\] {
  height: calc(100vh - 64px - 58px - 48px);
}
.h-\\[calc\\(100vh-84px\\)\\] {
  height: calc(100vh - 84px);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-max {
  height: -webkit-max-content;
  height: -moz-max-content;
  height: max-content;
}
.h-min {
  height: -webkit-min-content;
  height: -moz-min-content;
  height: min-content;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[250px\\] {
  max-height: 250px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[625px\\] {
  max-height: 625px;
}
.max-h-\\[98\\%\\] {
  max-height: 98%;
}
.max-h-dvh {
  max-height: 100dvh;
}
.min-h-\\[100vh\\] {
  min-height: 100vh;
}
.min-h-\\[110px\\] {
  min-height: 110px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[37px\\] {
  min-height: 37px;
}
.min-h-\\[38px\\] {
  min-height: 38px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[570px\\] {
  min-height: 570px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[615px\\] {
  min-height: 615px;
}
.min-h-\\[64px\\] {
  min-height: 64px;
}
.min-h-\\[86vh\\] {
  min-height: 86vh;
}
.min-h-\\[calc\\(100dvh-64px-58px-48px\\)\\] {
  min-height: calc(100dvh - 64px - 58px - 48px);
}
.min-h-\\[calc\\(100vh-64px-58px-48px\\)\\] {
  min-height: calc(100vh - 64px - 58px - 48px);
}
.min-h-calc-min-h-screen-150 {
  min-height: calc(100vh - 150px);
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-\\[20px\\] {
  width: 20px !important;
}
.\\!w-\\[320px\\] {
  width: 320px !important;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-\\[115px\\] {
  width: 115px;
}
.w-\\[12px\\] {
  width: 12px;
}
.w-\\[13px\\] {
  width: 13px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[175px\\] {
  width: 175px;
}
.w-\\[17px\\] {
  width: 17px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[185px\\] {
  width: 185px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[19px\\] {
  width: 19px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[202px\\] {
  width: 202px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[270px\\] {
  width: 270px;
}
.w-\\[272px\\] {
  width: 272px;
}
.w-\\[27px\\] {
  width: 27px;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[328px\\] {
  width: 328px;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[35px\\] {
  width: 35px;
}
.w-\\[365px\\] {
  width: 365px;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[375px\\] {
  width: 375px;
}
.w-\\[385px\\] {
  width: 385px;
}
.w-\\[390px\\] {
  width: 390px;
}
.w-\\[405px\\] {
  width: 405px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[42px\\] {
  width: 42px;
}
.w-\\[44px\\] {
  width: 44px;
}
.w-\\[5px\\] {
  width: 5px;
}
.w-\\[630px\\] {
  width: 630px;
}
.w-\\[680px\\] {
  width: 680px;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-\\[8px\\] {
  width: 8px;
}
.w-\\[95px\\] {
  width: 95px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-max {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}
.w-min {
  width: -webkit-min-content;
  width: -moz-min-content;
  width: min-content;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-12 {
  min-width: 3rem;
}
.min-w-32 {
  min-width: 8rem;
}
.min-w-36 {
  min-width: 9rem;
}
.min-w-40 {
  min-width: 10rem;
}
.min-w-44 {
  min-width: 11rem;
}
.min-w-48 {
  min-width: 12rem;
}
.min-w-5 {
  min-width: 1.25rem;
}
.min-w-60 {
  min-width: 15rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[110px\\] {
  min-width: 110px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[185px\\] {
  min-width: 185px;
}
.min-w-\\[190px\\] {
  min-width: 190px;
}
.min-w-\\[195px\\] {
  min-width: 195px;
}
.min-w-\\[260px\\] {
  min-width: 260px;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-\\[325px\\] {
  min-width: 325px;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[85px\\] {
  min-width: 85px;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[900px\\] {
  min-width: 900px;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.\\!max-w-\\[1200px\\] {
  max-width: 1200px !important;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-40 {
  max-width: 10rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-60 {
  max-width: 15rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-80 {
  max-width: 20rem;
}
.max-w-\\[1170px\\] {
  max-width: 1170px;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[185px\\] {
  max-width: 185px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[325px\\] {
  max-width: 325px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[440px\\] {
  max-width: 440px;
}
.max-w-\\[465px\\] {
  max-width: 465px;
}
.max-w-\\[50px\\] {
  max-width: 50px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[605px\\] {
  max-width: 605px;
}
.max-w-\\[690px\\] {
  max-width: 690px;
}
.max-w-\\[700px\\] {
  max-width: 700px;
}
.max-w-\\[710px\\] {
  max-width: 710px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[845px\\] {
  max-width: 845px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: -webkit-max-content;
  max-width: -moz-max-content;
  max-width: max-content;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.basis-full {
  flex-basis: 100%;
}
.caption-bottom {
  caption-side: bottom;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-left {
  transform-origin: left;
}
.origin-top-left {
  transform-origin: top left;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-240px\\] {
  --tw-translate-x: -240px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[0\\] {
  --tw-translate-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[650px\\] {
  --tw-translate-x: 650px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-90deg\\] {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.54\\] {
  --tw-scale-x: 0.54;
  --tw-scale-y: 0.54;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-scale-x-100 {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-\\[-1\\] {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!cursor-auto {
  cursor: auto !important;
}
.cursor-auto {
  cursor: auto;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.touch-none {
  touch-action: none;
}
.touch-manipulation {
  touch-action: manipulation;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.\\!list-disc {
  list-style-type: disc !important;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[100px\\2c 1fr\\] {
  grid-template-columns: 100px 1fr;
}
.grid-cols-\\[160px\\2c auto\\] {
  grid-template-columns: 160px auto;
}
.grid-cols-\\[170px_1fr\\] {
  grid-template-columns: 170px 1fr;
}
.grid-cols-\\[1fr\\2c 115px\\] {
  grid-template-columns: 1fr 115px;
}
.grid-cols-\\[1fr\\2c auto\\] {
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[1fr_290px\\] {
  grid-template-columns: 1fr 290px;
}
.grid-cols-\\[200px\\2c 1fr\\2c auto\\] {
  grid-template-columns: 200px 1fr auto;
}
.grid-cols-\\[200px\\2c auto\\] {
  grid-template-columns: 200px auto;
}
.grid-cols-\\[20px\\2c 2fr\\] {
  grid-template-columns: 20px 2fr;
}
.grid-cols-\\[220px\\2c auto\\] {
  grid-template-columns: 220px auto;
}
.grid-cols-\\[230px_1fr\\] {
  grid-template-columns: 230px 1fr;
}
.grid-cols-\\[244px_1fr\\] {
  grid-template-columns: 244px 1fr;
}
.grid-cols-\\[25px\\2c 1fr\\2c 20px\\] {
  grid-template-columns: 25px 1fr 20px;
}
.grid-cols-\\[34px\\2c auto\\2c 34px\\] {
  grid-template-columns: 34px auto 34px;
}
.grid-cols-\\[3fr\\2c 2fr\\] {
  grid-template-columns: 3fr 2fr;
}
.grid-cols-\\[405px\\2c 1fr\\] {
  grid-template-columns: 405px 1fr;
}
.grid-cols-\\[45\\%\\2c 1fr\\] {
  grid-template-columns: 45% 1fr;
}
.grid-cols-\\[50px\\2c 1fr\\] {
  grid-template-columns: 50px 1fr;
}
.grid-cols-\\[60px_1fr\\] {
  grid-template-columns: 60px 1fr;
}
.grid-cols-\\[90px_1fr\\] {
  grid-template-columns: 90px 1fr;
}
.grid-cols-\\[auto\\2c 1fr\\2c 1fr\\] {
  grid-template-columns: auto 1fr 1fr;
}
.grid-cols-\\[auto\\2c 1fr\\2c auto\\] {
  grid-template-columns: auto 1fr auto;
}
.grid-cols-\\[auto\\2c 1fr\\] {
  grid-template-columns: auto 1fr;
}
.grid-cols-\\[auto\\2c auto\\2c 1fr\\2c auto\\] {
  grid-template-columns: auto auto 1fr auto;
}
.grid-cols-\\[auto\\2c auto\\2c auto\\2c 1fr\\2c auto\\] {
  grid-template-columns: auto auto auto 1fr auto;
}
.grid-cols-\\[auto\\2c auto\\] {
  grid-template-columns: auto auto;
}
.grid-cols-\\[auto_450px\\] {
  grid-template-columns: auto 450px;
}
.grid-cols-\\[repeat\\(3\\2c auto\\)\\] {
  grid-template-columns: repeat(3,auto);
}
.grid-cols-\\[repeat\\(4\\2c 150px\\)\\] {
  grid-template-columns: repeat(4,150px);
}
.grid-rows-\\[1fr\\2c auto\\] {
  grid-template-rows: 1fr auto;
}
.grid-rows-\\[64px\\2c 1fr\\] {
  grid-template-rows: 64px 1fr;
}
.grid-rows-\\[auto\\2c 1fr\\2c auto\\] {
  grid-template-rows: auto 1fr auto;
}
.grid-rows-\\[auto\\2c 1fr\\] {
  grid-template-rows: auto 1fr;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-start {
  justify-items: start;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[30px\\] {
  gap: 30px;
}
.gap-\\[35px\\] {
  gap: 35px;
}
.gap-\\[37px\\] {
  gap: 37px;
}
.gap-\\[3px\\] {
  gap: 3px;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-\\[7px\\] {
  gap: 7px;
}
.gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-\\[10px\\] {
  -moz-column-gap: 10px;
       column-gap: 10px;
}
.gap-x-\\[20px\\] {
  -moz-column-gap: 20px;
       column-gap: 20px;
}
.gap-x-\\[5px\\] {
  -moz-column-gap: 5px;
       column-gap: 5px;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.gap-y-\\[10px\\] {
  row-gap: 10px;
}
.gap-y-\\[20px\\] {
  row-gap: 20px;
}
.gap-y-\\[25px\\] {
  row-gap: 25px;
}
.gap-y-\\[30px\\] {
  row-gap: 30px;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[25px\\] {
  border-radius: 25px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[3px\\] {
  border-radius: 3px;
}
.rounded-\\[50\\%\\] {
  border-radius: 50%;
}
.rounded-\\[50px\\] {
  border-radius: 50px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 6px;
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(6px - 2px);
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: calc(6px - 4px);
  border-radius: calc(var(--radius) - 4px);
}
.rounded-b-lg {
  border-bottom-right-radius: 6px;
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: 6px;
  border-bottom-left-radius: var(--radius);
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-lg {
  border-top-right-radius: 6px;
  border-top-right-radius: var(--radius);
  border-bottom-right-radius: 6px;
  border-bottom-right-radius: var(--radius);
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-\\[10px\\] {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-lg {
  border-top-left-radius: 6px;
  border-top-left-radius: var(--radius);
  border-top-right-radius: 6px;
  border-top-right-radius: var(--radius);
}
.rounded-br-\\[10px\\] {
  border-bottom-right-radius: 10px;
}
.rounded-tl-lg {
  border-top-left-radius: 6px;
  border-top-left-radius: var(--radius);
}
.rounded-tr-\\[10px\\] {
  border-top-right-radius: 10px;
}
.rounded-tr-lg {
  border-top-right-radius: 6px;
  border-top-right-radius: var(--radius);
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-\\[2px\\] {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-\\[4px\\] {
  border-left-width: 4px;
}
.border-l-\\[5px\\] {
  border-left-width: 5px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-none {
  border-style: none;
}
.\\!border-addition5 {
  border-color: hsla(184, 100%, 36%, 1) !important;
  border-color: var(--addition-5) !important;
}
.\\!border-destructive {
  border-color: #e0425b !important;
  border-color: var(--destructive) !important;
}
.\\!border-input {
  border-color: hsla(202, 44%, 28%, 0.1) !important;
  border-color: var(--input) !important;
}
.\\!border-white {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#1053FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(16 83 255 / var(--tw-border-opacity));
}
.border-\\[\\#11CE8C\\] {
  --tw-border-opacity: 1;
  border-color: rgb(17 206 140 / var(--tw-border-opacity));
}
.border-\\[\\#54C1FB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(84 193 251 / var(--tw-border-opacity));
}
.border-\\[\\#5ECA8F\\] {
  --tw-border-opacity: 1;
  border-color: rgb(94 202 143 / var(--tw-border-opacity));
}
.border-\\[\\#6D71F8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(109 113 248 / var(--tw-border-opacity));
}
.border-\\[\\#8D59FF33\\] {
  border-color: #8D59FF33;
}
.border-\\[\\#EF9F0080\\] {
  border-color: #EF9F0080;
}
.border-\\[\\#F4855E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(244 133 94 / var(--tw-border-opacity));
}
.border-\\[\\#FF8057\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 128 87 / var(--tw-border-opacity));
}
.border-\\[\\#FFFFFF66\\] {
  border-color: #FFFFFF66;
}
.border-\\[\\#FFFFFF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-\\[\\#f7f8fc\\] {
  --tw-border-opacity: 1;
  border-color: rgb(247 248 252 / var(--tw-border-opacity));
}
.border-addition1 {
  border-color: hsla(238, 30%, 22%, 1);
  border-color: var(--addition-1);
}
.border-addition10 {
  border-color: var(--addition-10);
}
.border-addition11 {
  border-color: var(--addition-11);
}
.border-addition4 {
  border-color: hsla(189, 100%, 41%, 1);
  border-color: var(--addition-4);
}
.border-addition5 {
  border-color: hsla(184, 100%, 36%, 1);
  border-color: var(--addition-5);
}
.border-addition6 {
  border-color: hsla(184, 41%, 66%, 1);
  border-color: var(--addition-6);
}
.border-addition7 {
  border-color: var(--addition-7);
}
.border-addition9 {
  border-color: var(--addition-9);
}
.border-destructive {
  border-color: #e0425b;
  border-color: var(--destructive);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-input {
  border-color: hsla(202, 44%, 28%, 0.1);
  border-color: var(--input);
}
.border-muted {
  border-color: hsla(210, 16%, 89%, 1);
  border-color: var(--muted);
}
.border-muted-foreground {
  border-color: hsla(202, 44%, 28%, 0.5);
  border-color: var(--muted-foreground);
}
.border-primary {
  border-color: hsla(202, 44%, 28%, 1);
  border-color: var(--primary);
}
.border-primary-text {
  border-color: hsla(202, 44%, 28%, 1);
  border-color: var(--primary-text);
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-secondary {
  border-color: hsla(351, 53%, 45%, 1);
  border-color: var(--secondary);
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.border-status-completed {
  border-color: hsla(169, 86%, 44%, 1);
  border-color: var(--completed);
}
.border-status-inactive {
  border-color: hsla(351, 72%, 57%, 1);
  border-color: var(--draft);
}
.border-status-late {
  border-color: hsla(238, 30%, 22%, 0.6);
  border-color: var(--late);
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-l-addition1 {
  border-left-color: hsla(238, 30%, 22%, 1);
  border-left-color: var(--addition-1);
}
.border-l-addition4 {
  border-left-color: hsla(189, 100%, 41%, 1);
  border-left-color: var(--addition-4);
}
.border-l-addition5 {
  border-left-color: hsla(184, 100%, 36%, 1);
  border-left-color: var(--addition-5);
}
.border-l-addition6 {
  border-left-color: hsla(184, 41%, 66%, 1);
  border-left-color: var(--addition-6);
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-t-transparent {
  border-top-color: transparent;
}
.border-opacity-50 {
  --tw-border-opacity: 0.5;
}
.\\!bg-\\[\\#522E5E\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(82 46 94 / var(--tw-bg-opacity)) !important;
}
.\\!bg-\\[\\#6D71F8\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(109 113 248 / var(--tw-bg-opacity)) !important;
}
.\\!bg-\\[\\#965BF3\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(150 91 243 / var(--tw-bg-opacity)) !important;
}
.\\!bg-addition5 {
  background-color: hsla(184, 100%, 36%, 1) !important;
  background-color: var(--addition-5) !important;
}
.\\!bg-primary {
  background-color: hsla(202, 44%, 28%, 1) !important;
  background-color: var(--primary) !important;
}
.\\!bg-secondary {
  background-color: hsla(351, 53%, 45%, 1) !important;
  background-color: var(--secondary) !important;
}
.\\!bg-secondary-10 {
  background-color: color-mix(in srgb, hsla(351, 53%, 45%, 1) 10%, transparent) !important;
  background-color: color-mix(in srgb, var(--secondary) 10%, transparent) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#284F6612\\] {
  background-color: #284F6612;
}
.bg-\\[\\#307BB2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(48 123 178 / var(--tw-bg-opacity));
}
.bg-\\[\\#4C90BF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(76 144 191 / var(--tw-bg-opacity));
}
.bg-\\[\\#51CF7C1A\\] {
  background-color: #51CF7C1A;
}
.bg-\\[\\#51CF7C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(81 207 124 / var(--tw-bg-opacity));
}
.bg-\\[\\#5582B42E\\] {
  background-color: #5582B42E;
}
.bg-\\[\\#68A25A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(104 162 90 / var(--tw-bg-opacity));
}
.bg-\\[\\#82b6ed\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(130 182 237 / var(--tw-bg-opacity));
}
.bg-\\[\\#8794AC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(135 148 172 / var(--tw-bg-opacity));
}
.bg-\\[\\#8D59FF08\\] {
  background-color: #8D59FF08;
}
.bg-\\[\\#8D59FF1A\\] {
  background-color: #8D59FF1A;
}
.bg-\\[\\#8D59FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(141 89 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#D6E6DF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(214 230 223 / var(--tw-bg-opacity));
}
.bg-\\[\\#D6F3FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(214 243 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#EF9F00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 159 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#F5F7F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 247 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#F8F9FD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 253 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF1A\\] {
  background-color: #FFFFFF1A;
}
.bg-\\[\\#FFFFFF57\\] {
  background-color: #FFFFFF57;
}
.bg-\\[\\#FFFFFF99\\] {
  background-color: #FFFFFF99;
}
.bg-\\[\\#c6cfdb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(198 207 219 / var(--tw-bg-opacity));
}
.bg-\\[\\#e2e4e7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 228 231 / var(--tw-bg-opacity));
}
.bg-\\[\\#ebedee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 237 238 / var(--tw-bg-opacity));
}
.bg-\\[\\#f7f8fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 248 252 / var(--tw-bg-opacity));
}
.bg-accent {
  background-color: var(--accent);
}
.bg-addition1 {
  background-color: hsla(238, 30%, 22%, 1);
  background-color: var(--addition-1);
}
.bg-addition10 {
  background-color: var(--addition-10);
}
.bg-addition11-5 {
  background-color: color-mix(in srgb, var(--addition-11) 5%, transparent);
}
.bg-addition2 {
  background-color: hsla(211, 67%, 42%, 1);
  background-color: var(--addition-2);
}
.bg-addition4 {
  background-color: hsla(189, 100%, 41%, 1);
  background-color: var(--addition-4);
}
.bg-addition4-20 {
  background-color: color-mix(in srgb, hsla(189, 100%, 41%, 1) 20%, transparent);
  background-color: color-mix(in srgb, var(--addition-4) 20%, transparent);
}
.bg-addition5 {
  background-color: hsla(184, 100%, 36%, 1);
  background-color: var(--addition-5);
}
.bg-addition6 {
  background-color: hsla(184, 41%, 66%, 1);
  background-color: var(--addition-6);
}
.bg-addition6-20 {
  background-color: color-mix(in srgb, hsla(184, 41%, 66%, 1) 20%, transparent);
  background-color: color-mix(in srgb, var(--addition-6) 20%, transparent);
}
.bg-addition6-3 {
  background-color: color-mix(in srgb, hsla(184, 41%, 66%, 1) 3%, transparent);
  background-color: color-mix(in srgb, var(--addition-6) 3%, transparent);
}
.bg-addition6-5 {
  background-color: color-mix(in srgb, hsla(184, 41%, 66%, 1) 5%, transparent);
  background-color: color-mix(in srgb, var(--addition-6) 5%, transparent);
}
.bg-addition7 {
  background-color: var(--addition-7);
}
.bg-addition8 {
  background-color: var(--addition-8);
}
.bg-addition9 {
  background-color: var(--addition-9);
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity));
}
.bg-background {
  background-color: hsla(220, 33%, 99%, 1);
  background-color: var(--background);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-border {
  background-color: hsla(202, 44%, 28%, 0.1);
  background-color: var(--border);
}
.bg-card {
  background-color: var(--card);
}
.bg-destructive {
  background-color: #e0425b;
  background-color: var(--destructive);
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-inherit {
  background-color: inherit;
}
.bg-inputBg {
  background-color: hsla(202, 44%, 28%, 0.07);
  background-color: var(--input-bg);
}
.bg-lightGray {
  background-color: #fbfbfd;
  background-color: var(--light-gray);
}
.bg-lightGray2 {
  background-color: #f8f8f8;
  background-color: var(--light-gray-2);
}
.bg-muted {
  background-color: hsla(210, 16%, 89%, 1);
  background-color: var(--muted);
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}
.bg-popover {
  background-color: hsla(0, 0%, 100%);
  background-color: var(--popover);
}
.bg-primary {
  background-color: hsla(202, 44%, 28%, 1);
  background-color: var(--primary);
}
.bg-primary-10 {
  background-color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 10%, transparent);
  background-color: color-mix(in srgb, var(--primary) 10%, transparent);
}
.bg-primary-5 {
  background-color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 5%, transparent);
  background-color: color-mix(in srgb, var(--primary) 5%, transparent);
}
.bg-primary-7 {
  background-color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 7%, transparent);
  background-color: color-mix(in srgb, var(--primary) 7%, transparent);
}
.bg-primary-80 {
  background-color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 80%, transparent);
  background-color: color-mix(in srgb, var(--primary) 80%, transparent);
}
.bg-primary-foreground {
  background-color: #fff;
  background-color: var(--primary-foreground);
}
.bg-primary-text {
  background-color: hsla(202, 44%, 28%, 1);
  background-color: var(--primary-text);
}
.bg-secondary {
  background-color: hsla(351, 53%, 45%, 1);
  background-color: var(--secondary);
}
.bg-secondary-10 {
  background-color: color-mix(in srgb, hsla(351, 53%, 45%, 1) 10%, transparent);
  background-color: color-mix(in srgb, var(--secondary) 10%, transparent);
}
.bg-secondary-3 {
  background-color: color-mix(in srgb, hsla(351, 53%, 45%, 1) 3%, transparent);
  background-color: color-mix(in srgb, var(--secondary) 3%, transparent);
}
.bg-secondaryButton {
  background-color: hsla(202, 44%, 28%, 0.15);
  background-color: var(--secondary-button);
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-home-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.from-addition5 {
  --tw-gradient-from: var(--addition-5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-600 {
  --tw-gradient-from: #0284c7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 132 199 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-blue-100 {
  --tw-gradient-to: rgb(219 234 254 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #dbeafe var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-addition6 {
  --tw-gradient-to: var(--addition-6) var(--tw-gradient-to-position);
}
.to-indigo-800 {
  --tw-gradient-to: #3730a3 var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.fill-addition6-20 {
  fill: color-mix(in srgb, hsla(184, 41%, 66%, 1) 20%, transparent);
  fill: color-mix(in srgb, var(--addition-6) 20%, transparent);
}
.fill-addition6-30 {
  fill: color-mix(in srgb, hsla(184, 41%, 66%, 1) 30%, transparent);
  fill: color-mix(in srgb, var(--addition-6) 30%, transparent);
}
.fill-current {
  fill: currentColor;
}
.fill-white {
  fill: #fff;
}
.object-contain {
  object-fit: contain;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[10px_0_40px_75px\\] {
  padding: 10px 0 40px 75px;
}
.p-\\[10px_15px\\] {
  padding: 10px 15px;
}
.p-\\[10px_20px\\] {
  padding: 10px 20px;
}
.p-\\[15px\\] {
  padding: 15px;
}
.p-\\[15px_20px\\] {
  padding: 15px 20px;
}
.p-\\[16px\\] {
  padding: 16px;
}
.p-\\[1px\\] {
  padding: 1px;
}
.p-\\[20px\\] {
  padding: 20px;
}
.p-\\[2px\\] {
  padding: 2px;
}
.p-\\[30px\\] {
  padding: 30px;
}
.p-\\[5px\\] {
  padding: 5px;
}
.p-\\[5px_10px\\] {
  padding: 5px 10px;
}
.p-\\[5px_8px\\] {
  padding: 5px 8px;
}
.p-\\[6px_10px\\] {
  padding: 6px 10px;
}
.p-\\[7px\\] {
  padding: 7px;
}
.p-\\[8px_10px\\] {
  padding: 8px 10px;
}
.\\!px-\\[10px\\] {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.\\!px-\\[20px\\] {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.\\!py-\\[5px\\] {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[22px\\] {
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}
.px-\\[35px\\] {
  padding-left: 35px;
  padding-right: 35px;
}
.px-\\[36px\\] {
  padding-left: 36px;
  padding-right: 36px;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-\\[70px\\] {
  padding-left: 70px;
  padding-right: 70px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\] {
  padding-top: 0;
  padding-bottom: 0;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;
}
.py-\\[9px\\] {
  padding-top: 9px;
  padding-bottom: 9px;
}
.\\!pl-\\[30px\\] {
  padding-left: 30px !important;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.pb-\\[20px\\] {
  padding-bottom: 20px;
}
.pb-\\[30px\\] {
  padding-bottom: 30px;
}
.pb-\\[3px\\] {
  padding-bottom: 3px;
}
.pb-\\[40px\\] {
  padding-bottom: 40px;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-14 {
  padding-left: 3.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-\\[10px\\] {
  padding-left: 10px;
}
.pl-\\[32px\\] {
  padding-left: 32px;
}
.pl-\\[37px\\] {
  padding-left: 37px;
}
.pl-\\[3px\\] {
  padding-left: 3px;
}
.pl-\\[40px\\] {
  padding-left: 40px;
}
.pl-\\[50px\\] {
  padding-left: 50px;
}
.pl-\\[60px\\] {
  padding-left: 60px;
}
.pl-\\[80px\\] {
  padding-left: 80px;
}
.pr-0 {
  padding-right: 0px;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-16 {
  padding-right: 4rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pr-\\[20px\\] {
  padding-right: 20px;
}
.pr-\\[30px\\] {
  padding-right: 30px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pt-\\[15px\\] {
  padding-top: 15px;
}
.pt-\\[17px\\] {
  padding-top: 17px;
}
.pt-\\[5px\\] {
  padding-top: 5px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-helvetica {
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
}
.\\!text-sm {
  font-size: 14px !important;
  line-height: 22px !important;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-base {
  font-size: 16px;
  line-height: 24px;
}
.text-lg {
  font-size: 20px;
  line-height: 28px;
}
.text-sm {
  font-size: 14px;
  line-height: 22px;
}
.text-xl {
  font-size: 24px;
  line-height: 32px;
}
.text-xs {
  font-size: 12px;
  line-height: 18px;
}
.font-\\[14px\\] {
  font-weight: 14px;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.\\!leading-\\[14px\\] {
  line-height: 14px !important;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-\\[12px\\] {
  line-height: 12px;
}
.leading-\\[14px\\] {
  line-height: 14px;
}
.leading-\\[15px\\] {
  line-height: 15px;
}
.leading-\\[16px\\] {
  line-height: 16px;
}
.leading-\\[17px\\] {
  line-height: 17px;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.leading-\\[19px\\] {
  line-height: 19px;
}
.leading-\\[20px\\] {
  line-height: 20px;
}
.leading-\\[24px\\] {
  line-height: 24px;
}
.leading-none {
  line-height: 1;
}
.tracking-\\[0\\.1px\\] {
  letter-spacing: 0.1px;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-\\[\\#8794AC\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(135 148 172 / var(--tw-text-opacity)) !important;
}
.\\!text-addition1 {
  color: hsla(238, 30%, 22%, 1) !important;
  color: var(--addition-1) !important;
}
.\\!text-addition11 {
  color: var(--addition-11) !important;
}
.\\!text-addition5 {
  color: hsla(184, 100%, 36%, 1) !important;
  color: var(--addition-5) !important;
}
.\\!text-destructive {
  color: #e0425b !important;
  color: var(--destructive) !important;
}
.\\!text-primary-foreground {
  color: #fff !important;
  color: var(--primary-foreground) !important;
}
.\\!text-secondary {
  color: hsla(351, 53%, 45%, 1) !important;
  color: var(--secondary) !important;
}
.\\!text-secondary-80 {
  color: color-mix(in srgb, hsla(351, 53%, 45%, 1) 80%, transparent) !important;
  color: color-mix(in srgb, var(--secondary) 80%, transparent) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#02B3CB\\] {
  --tw-text-opacity: 1;
  color: rgb(2 179 203 / var(--tw-text-opacity));
}
.text-\\[\\#1053FF\\] {
  --tw-text-opacity: 1;
  color: rgb(16 83 255 / var(--tw-text-opacity));
}
.text-\\[\\#1119FF\\] {
  --tw-text-opacity: 1;
  color: rgb(17 25 255 / var(--tw-text-opacity));
}
.text-\\[\\#11CE8C\\] {
  --tw-text-opacity: 1;
  color: rgb(17 206 140 / var(--tw-text-opacity));
}
.text-\\[\\#202020\\] {
  --tw-text-opacity: 1;
  color: rgb(32 32 32 / var(--tw-text-opacity));
}
.text-\\[\\#2368B4\\] {
  --tw-text-opacity: 1;
  color: rgb(35 104 180 / var(--tw-text-opacity));
}
.text-\\[\\#51CF7C\\] {
  --tw-text-opacity: 1;
  color: rgb(81 207 124 / var(--tw-text-opacity));
}
.text-\\[\\#54C1FB\\] {
  --tw-text-opacity: 1;
  color: rgb(84 193 251 / var(--tw-text-opacity));
}
.text-\\[\\#555\\] {
  --tw-text-opacity: 1;
  color: rgb(85 85 85 / var(--tw-text-opacity));
}
.text-\\[\\#5ECA8F\\] {
  --tw-text-opacity: 1;
  color: rgb(94 202 143 / var(--tw-text-opacity));
}
.text-\\[\\#6D71F8\\] {
  --tw-text-opacity: 1;
  color: rgb(109 113 248 / var(--tw-text-opacity));
}
.text-\\[\\#808080\\] {
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity));
}
.text-\\[\\#898989\\] {
  --tw-text-opacity: 1;
  color: rgb(137 137 137 / var(--tw-text-opacity));
}
.text-\\[\\#8D59FF\\] {
  --tw-text-opacity: 1;
  color: rgb(141 89 255 / var(--tw-text-opacity));
}
.text-\\[\\#EF9F00CC\\] {
  color: #EF9F00CC;
}
.text-\\[\\#EF9F00\\] {
  --tw-text-opacity: 1;
  color: rgb(239 159 0 / var(--tw-text-opacity));
}
.text-\\[\\#F25B2A\\] {
  --tw-text-opacity: 1;
  color: rgb(242 91 42 / var(--tw-text-opacity));
}
.text-\\[\\#F4855E\\] {
  --tw-text-opacity: 1;
  color: rgb(244 133 94 / var(--tw-text-opacity));
}
.text-\\[\\#FF8057\\] {
  --tw-text-opacity: 1;
  color: rgb(255 128 87 / var(--tw-text-opacity));
}
.text-accent-foreground {
  color: var(--accent-foreground);
}
.text-addition1 {
  color: hsla(238, 30%, 22%, 1);
  color: var(--addition-1);
}
.text-addition1-50 {
  color: color-mix(in srgb, hsla(238, 30%, 22%, 1) 50%, transparent);
  color: color-mix(in srgb, var(--addition-1) 50%, transparent);
}
.text-addition1-60 {
  color: color-mix(in srgb, hsla(238, 30%, 22%, 1) 60%, transparent);
  color: color-mix(in srgb, var(--addition-1) 60%, transparent);
}
.text-addition1-70 {
  color: color-mix(in srgb, hsla(238, 30%, 22%, 1) 70%, transparent);
  color: color-mix(in srgb, var(--addition-1) 70%, transparent);
}
.text-addition10 {
  color: var(--addition-10);
}
.text-addition11 {
  color: var(--addition-11);
}
.text-addition11-30 {
  color: color-mix(in srgb, var(--addition-11) 30%, transparent);
}
.text-addition11-40 {
  color: color-mix(in srgb, var(--addition-11) 40%, transparent);
}
.text-addition11-50 {
  color: color-mix(in srgb, var(--addition-11) 50%, transparent);
}
.text-addition2 {
  color: hsla(211, 67%, 42%, 1);
  color: var(--addition-2);
}
.text-addition4 {
  color: hsla(189, 100%, 41%, 1);
  color: var(--addition-4);
}
.text-addition5 {
  color: hsla(184, 100%, 36%, 1);
  color: var(--addition-5);
}
.text-addition6 {
  color: hsla(184, 41%, 66%, 1);
  color: var(--addition-6);
}
.text-addition7 {
  color: var(--addition-7);
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-card-foreground {
  color: var(--card-foreground);
}
.text-current {
  color: currentColor;
}
.text-destructive {
  color: #e0425b;
  color: var(--destructive);
}
.text-destructive-foreground {
  color: var(--destructive-foreground);
}
.text-foreground {
  color: var(--foreground);
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-label {
  color: hsla(202, 44%, 28%, 0.7);
  color: var(--label);
}
.text-muted {
  color: hsla(210, 16%, 89%, 1);
  color: var(--muted);
}
.text-muted-foreground {
  color: hsla(202, 44%, 28%, 0.5);
  color: var(--muted-foreground);
}
.text-placeholder {
  color: #63748b;
  color: var(--placeholder);
}
.text-popover-foreground {
  color: hsla(240, 10%, 3.9%);
  color: var(--popover-foreground);
}
.text-primary {
  color: hsla(202, 44%, 28%, 1);
  color: var(--primary);
}
.text-primary-60 {
  color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 60%, transparent);
  color: color-mix(in srgb, var(--primary) 60%, transparent);
}
.text-primary-70 {
  color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 70%, transparent);
  color: color-mix(in srgb, var(--primary) 70%, transparent);
}
.text-primary-80 {
  color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 80%, transparent);
  color: color-mix(in srgb, var(--primary) 80%, transparent);
}
.text-primary-foreground {
  color: #fff;
  color: var(--primary-foreground);
}
.text-primary-text {
  color: hsla(202, 44%, 28%, 1);
  color: var(--primary-text);
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-secondary {
  color: hsla(351, 53%, 45%, 1);
  color: var(--secondary);
}
.text-secondary-50 {
  color: color-mix(in srgb, hsla(351, 53%, 45%, 1) 50%, transparent);
  color: color-mix(in srgb, var(--secondary) 50%, transparent);
}
.text-secondary-80 {
  color: color-mix(in srgb, hsla(351, 53%, 45%, 1) 80%, transparent);
  color: color-mix(in srgb, var(--secondary) 80%, transparent);
}
.text-secondary-foreground {
  color: var(--secondary-foreground);
}
.text-secondary2 {
  color: var(--secondary-2);
}
.text-secondaryButton-foreground {
  color: hsla(202, 44%, 28%, 1);
  color: var(--primary);
}
.text-status-approved {
  color: hsla(191, 57%, 51%, 1);
  color: var(--approved);
}
.text-status-completed {
  color: hsla(169, 86%, 44%, 1);
  color: var(--completed);
}
.text-status-delivered {
  color: hsla(202, 79%, 51%, 1);
  color: var(--delivered);
}
.text-status-done {
  color: hsla(169, 86%, 44%, 1);
  color: var(--done);
}
.text-status-draft {
  color: hsla(351, 72%, 57%, 1);
  color: var(--draft);
}
.text-status-earlyDrop {
  color: hsla(202, 79%, 51%, 1);
  color: var(--earlyDrop);
}
.text-status-inactive {
  color: hsla(351, 72%, 57%, 1);
  color: var(--draft);
}
.text-status-late {
  color: hsla(238, 30%, 22%, 0.6);
  color: var(--late);
}
.text-status-pending {
  color: hsla(187, 62%, 47%, 1);
  color: var(--pending);
}
.text-status-running {
  color: hsla(35, 82%, 51%, 1);
  color: var(--running);
}
.text-status-scheduled {
  color: hsla(40, 100%, 50%, 1);
  color: var(--scheduled);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.\\!opacity-100 {
  opacity: 1 !important;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 8px 24px rgba(0,0,0,0.12);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 8px 30px rgba(0,0,0,0.4);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 6px 0px 40px 0px #2728481A;
  --tw-shadow-colored: 6px 0px 40px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-offset-background {
  --tw-ring-offset-color: var(--background);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-none {
  --tw-blur: blur(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-\\[\\.45\\] {
  --tw-brightness: brightness(.45);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none {
  transition-property: none;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
@keyframes enter {

  from {
    opacity: 1;
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: 1;
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.duration-150 {
  animation-duration: 150ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  animation-timing-function: linear;
}
.running {
  animation-play-state: running;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff");
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
::-webkit-scrollbar {
  width: 0;
}

:root {
  --placeholder: #63748b;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

ul[class],
ol[class] {
  padding: 0;
}

body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
li,
figure,
figcaption,
blockquote,
dl,
dd {
  margin: 0;
}

body {
  min-height: 100vh;
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  line-height: 1.5;
  font-family: "Arial", serif;
}

html body[data-page-scrollable][data-scroll-locked] {
  padding-right: 15px !important;
}

ul[class],
ol[class] {
  list-style: none;
}

a:not([class]) {
  text-decoration: none;
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
}

img {
  max-width: 100%;
  display: block;
}

input,
button,
textarea,
select {
  font: inherit;
}

input[type=number] {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

html,
body {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  font-family: "DM Sans";
}

#root {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
}
#root > * {
  max-width: 2560px;
  box-shadow: 0 0 50px #eee;
}

/** Animation for plus-minus icon */
.plus rect {
  transition: transform 250ms ease-in-out, opacity 250ms ease-in-out;
  transform: rotate(0deg);
  transform-origin: 50% 50%;
}

.minus .vertical-line {
  transform: rotate(90deg);
  opacity: 0.5;
}

.logo path {
  fill: revert-layer !important;
}

.rdp-vhidden {
  display: none;
}

.rdp-dropdown_month .text-sm,
.rdp-dropdown_year .text-sm {
  display: none;
}

body.overlay.lightbox-open:before {
  display: block;
}
body.overlay:before {
  content: "";
  position: fixed;
  top: 0;
  display: none;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99;
}

.html-email-content *, .html-email-content p, .html-email-content h1, .html-email-content h2, .html-email-content h3, .html-email-content h4, .html-email-content h5, .html-email-content h6, .html-email-content strong, .html-email-content em, .html-email-content b, .html-email-content i, .html-email-content ul, .html-email-content ol, .html-email-content li, .html-email-content blockquote, .html-email-content pre, .html-email-content code {
  all: revert;
  line-height: 1.15;
}
.html-email-content table {
  border-collapse: collapse;
}
.html-email-content th, .html-email-content td {
  border: 1px solid #333;
  padding: 10px;
}
.html-email-content a {
  color: #4582ec;
}
.first-letter\\:uppercase::first-letter {
  text-transform: uppercase;
}
.file\\:border-0::-webkit-file-upload-button {
  border-width: 0px;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-transparent::-webkit-file-upload-button {
  background-color: transparent;
}
.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}
.file\\:text-sm::-webkit-file-upload-button {
  font-size: 14px;
  line-height: 22px;
}
.file\\:text-sm::file-selector-button {
  font-size: 14px;
  line-height: 22px;
}
.file\\:font-medium::-webkit-file-upload-button {
  font-weight: 500;
}
.file\\:font-medium::file-selector-button {
  font-weight: 500;
}
.placeholder\\:text-\\[\\#FFFFFF80\\]::-moz-placeholder {
  color: #FFFFFF80;
}
.placeholder\\:text-\\[\\#FFFFFF80\\]::placeholder {
  color: #FFFFFF80;
}
.placeholder\\:text-muted-foreground::-moz-placeholder {
  color: hsla(202, 44%, 28%, 0.5);
  color: var(--muted-foreground);
}
.placeholder\\:text-muted-foreground::placeholder {
  color: hsla(202, 44%, 28%, 0.5);
  color: var(--muted-foreground);
}
.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:bottom-\\[-7px\\]::before {
  content: var(--tw-content);
  bottom: -7px;
}
.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}
.before\\:left-\\[-10px\\]::before {
  content: var(--tw-content);
  left: -10px;
}
.before\\:left-\\[130px\\]::before {
  content: var(--tw-content);
  left: 130px;
}
.before\\:right-0::before {
  content: var(--tw-content);
  right: 0px;
}
.before\\:right-\\[-10px\\]::before {
  content: var(--tw-content);
  right: -10px;
}
.before\\:right-\\[65px\\]::before {
  content: var(--tw-content);
  right: 65px;
}
.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}
.before\\:top-\\[-15px\\]::before {
  content: var(--tw-content);
  top: -15px;
}
.before\\:top-\\[-5px\\]::before {
  content: var(--tw-content);
  top: -5px;
}
.before\\:top-\\[86px\\]::before {
  content: var(--tw-content);
  top: 86px;
}
.before\\:z-0::before {
  content: var(--tw-content);
  z-index: 0;
}
.before\\:z-\\[-1\\]::before {
  content: var(--tw-content);
  z-index: -1;
}
.before\\:m-auto::before {
  content: var(--tw-content);
  margin: auto;
}
.before\\:h-\\[10px\\]::before {
  content: var(--tw-content);
  height: 10px;
}
.before\\:h-\\[135px\\]::before {
  content: var(--tw-content);
  height: 135px;
}
.before\\:h-\\[20px\\]::before {
  content: var(--tw-content);
  height: 20px;
}
.before\\:h-\\[30px\\]::before {
  content: var(--tw-content);
  height: 30px;
}
.before\\:h-\\[5px\\]::before {
  content: var(--tw-content);
  height: 5px;
}
.before\\:h-full::before {
  content: var(--tw-content);
  height: 100%;
}
.before\\:w-\\[10px\\]::before {
  content: var(--tw-content);
  width: 10px;
}
.before\\:w-\\[15px\\]::before {
  content: var(--tw-content);
  width: 15px;
}
.before\\:w-\\[1px\\]::before {
  content: var(--tw-content);
  width: 1px;
}
.before\\:w-\\[30px\\]::before {
  content: var(--tw-content);
  width: 30px;
}
.before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}
.before\\:rotate-45::before {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:rounded-b-\\[5px\\]::before {
  content: var(--tw-content);
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.before\\:rounded-br-\\[50px\\]::before {
  content: var(--tw-content);
  border-bottom-right-radius: 50px;
}
.before\\:rounded-tr-\\[50px\\]::before {
  content: var(--tw-content);
  border-top-right-radius: 50px;
}
.before\\:bg-\\[\\#6D71F81A\\]::before {
  content: var(--tw-content);
  background-color: #6D71F81A;
}
.before\\:bg-current::before {
  content: var(--tw-content);
  background-color: currentColor;
}
.before\\:bg-primary-60::before {
  content: var(--tw-content);
  background-color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 60%, transparent);
  background-color: color-mix(in srgb, var(--primary) 60%, transparent);
}
.before\\:bg-secondary::before {
  content: var(--tw-content);
  background-color: hsla(351, 53%, 45%, 1);
  background-color: var(--secondary);
}
.before\\:bg-white::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.before\\:text-\\[10px\\]::before {
  content: var(--tw-content);
  font-size: 10px;
}
.before\\:text-addition6::before {
  content: var(--tw-content);
  color: hsla(184, 41%, 66%, 1);
  color: var(--addition-6);
}
.before\\:transition::before {
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.before\\:duration-150::before {
  content: var(--tw-content);
  transition-duration: 150ms;
}
.before\\:ease-in-out::before {
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.before\\:content-\\[\\"\\"\\]::before {
  --tw-content: "";
  content: var(--tw-content);
}
.before\\:content-\\[\\"\\25BC\\"\\]::before {
  --tw-content: "▼";
  content: var(--tw-content);
}
.before\\:duration-150::before {
  content: var(--tw-content);
  animation-duration: 150ms;
}
.before\\:ease-in-out::before {
  content: var(--tw-content);
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.last\\:hidden:last-child {
  display: none;
}
.focus-within\\:relative:focus-within {
  position: relative;
}
.focus-within\\:z-20:focus-within {
  z-index: 20;
}
.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-primary:focus-within {
  --tw-ring-color: var(--primary);
}
.focus-within\\:ring-red-500:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity));
}
.hover\\:translate-x-\\[-10px\\]:hover {
  --tw-translate-x: -10px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.hover\\:\\!bg-transparent:hover {
  background-color: transparent !important;
}
.hover\\:bg-\\[\\#009DA8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 157 168 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#1053FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 83 255 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#51CF7CE6\\]:hover {
  background-color: #51CF7CE6;
}
.hover\\:bg-\\[\\#51cf7c2e\\]:hover {
  background-color: #51cf7c2e;
}
.hover\\:bg-\\[\\#51cf7cd1\\]:hover {
  background-color: #51cf7cd1;
}
.hover\\:bg-\\[\\#54C1FB\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(84 193 251 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#5ECA8F\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(94 202 143 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#8D59FF2A\\]:hover {
  background-color: #8D59FF2A;
}
.hover\\:bg-\\[\\#EF9F00E6\\]:hover {
  background-color: #EF9F00E6;
}
.hover\\:bg-\\[\\#F4855E\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 133 94 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#d8dfe1\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(216 223 225 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#eee\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#ef9f00e6\\]:hover {
  background-color: #ef9f00e6;
}
.hover\\:bg-\\[muted\\]:hover {
  background-color: muted;
}
.hover\\:bg-accent:hover {
  background-color: var(--accent);
}
.hover\\:bg-addition10:hover {
  background-color: var(--addition-10);
}
.hover\\:bg-addition10-80:hover {
  background-color: color-mix(in srgb, var(--addition-10) 80%, transparent);
}
.hover\\:bg-addition4-10:hover {
  background-color: color-mix(in srgb, hsla(189, 100%, 41%, 1) 10%, transparent);
  background-color: color-mix(in srgb, var(--addition-4) 10%, transparent);
}
.hover\\:bg-addition4-20:hover {
  background-color: color-mix(in srgb, hsla(189, 100%, 41%, 1) 20%, transparent);
  background-color: color-mix(in srgb, var(--addition-4) 20%, transparent);
}
.hover\\:bg-addition5:hover {
  background-color: hsla(184, 100%, 36%, 1);
  background-color: var(--addition-5);
}
.hover\\:bg-destructive:hover {
  background-color: #e0425b;
  background-color: var(--destructive);
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.hover\\:bg-inputBg:hover {
  background-color: hsla(202, 44%, 28%, 0.07);
  background-color: var(--input-bg);
}
.hover\\:bg-muted:hover {
  background-color: hsla(210, 16%, 89%, 1);
  background-color: var(--muted);
}
.hover\\:bg-primary:hover {
  background-color: hsla(202, 44%, 28%, 1);
  background-color: var(--primary);
}
.hover\\:bg-primary-80:hover {
  background-color: color-mix(in srgb, hsla(202, 44%, 28%, 1) 80%, transparent);
  background-color: color-mix(in srgb, var(--primary) 80%, transparent);
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.hover\\:bg-secondary-7:hover {
  background-color: color-mix(in srgb, hsla(351, 53%, 45%, 1) 7%, transparent);
  background-color: color-mix(in srgb, var(--secondary) 7%, transparent);
}
.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/70:hover {
  background-color: rgb(255 255 255 / 0.7);
}
.hover\\:fill-addition6-30:hover {
  fill: color-mix(in srgb, hsla(184, 41%, 66%, 1) 30%, transparent);
  fill: color-mix(in srgb, var(--addition-6) 30%, transparent);
}
.hover\\:fill-muted:hover {
  fill: hsla(210, 16%, 89%, 1);
  fill: var(--muted);
}
.hover\\:font-medium:hover {
  font-weight: 500;
}
.hover\\:text-\\[\\#2a6496\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(42 100 150 / var(--tw-text-opacity));
}
.hover\\:text-accent-foreground:hover {
  color: var(--accent-foreground);
}
.hover\\:text-addition1:hover {
  color: hsla(238, 30%, 22%, 1);
  color: var(--addition-1);
}
.hover\\:text-addition7:hover {
  color: var(--addition-7);
}
.hover\\:text-destructive:hover {
  color: #e0425b;
  color: var(--destructive);
}
.hover\\:text-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.hover\\:text-muted-foreground:hover {
  color: hsla(202, 44%, 28%, 0.5);
  color: var(--muted-foreground);
}
.hover\\:text-primary:hover {
  color: hsla(202, 44%, 28%, 1);
  color: var(--primary);
}
.hover\\:text-primary-foreground:hover {
  color: #fff;
  color: var(--primary-foreground);
}
.hover\\:text-primary-text:hover {
  color: hsla(202, 44%, 28%, 1);
  color: var(--primary-text);
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.hover\\:text-slate-300:hover {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.hover\\:text-slate-600:hover {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:no-underline:hover {
  text-decoration-line: none;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-60:hover {
  opacity: 0.6;
}
.hover\\:opacity-70:hover {
  opacity: 0.7;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-85:hover {
  opacity: 0.85;
}
.hover\\:before\\:-translate-y-\\[-5px\\]:hover::before {
  content: var(--tw-content);
  --tw-translate-y: 5px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.focus\\:border-primary:focus {
  border-color: hsla(202, 44%, 28%, 1);
  border-color: var(--primary);
}
.focus\\:\\!bg-addition3:focus {
  background-color: hsla(205, 58%, 44%, 1) !important;
  background-color: var(--addition-3) !important;
}
.focus\\:bg-accent:focus {
  background-color: var(--accent);
}
.focus\\:bg-primary:focus {
  background-color: hsla(202, 44%, 28%, 1);
  background-color: var(--primary);
}
.focus\\:\\!text-addition3-foreground:focus {
  color: #fff !important;
  color: var(--white) !important;
}
.focus\\:text-accent-foreground:focus {
  color: var(--accent-foreground);
}
.focus\\:text-primary-foreground:focus {
  color: #fff;
  color: var(--primary-foreground);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-ring:focus {
  --tw-ring-color: var(--ring);
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:\\!ring-destructive:focus-visible {
  --tw-ring-color: var(--destructive) !important;
}
.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: var(--ring);
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: var(--background);
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:\\!bg-transparent:disabled {
  background-color: transparent !important;
}
.disabled\\:bg-\\[\\#8794AC\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(135 148 172 / var(--tw-bg-opacity));
}
.disabled\\:bg-muted:disabled {
  background-color: hsla(210, 16%, 89%, 1);
  background-color: var(--muted);
}
.disabled\\:bg-transparent:disabled {
  background-color: transparent;
}
.disabled\\:text-muted:disabled {
  color: hsla(210, 16%, 89%, 1);
  color: var(--muted);
}
.disabled\\:text-secondaryButton-foreground:disabled {
  color: hsla(202, 44%, 28%, 1);
  color: var(--primary);
}
.disabled\\:text-white:disabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.group:hover .group-hover\\:visible {
  visibility: visible;
}
.group:hover .group-hover\\:block {
  display: block;
}
.group:hover .group-hover\\:border-secondary {
  border-color: hsla(351, 53%, 45%, 1);
  border-color: var(--secondary);
}
.group:hover .group-hover\\:bg-secondary {
  background-color: hsla(351, 53%, 45%, 1);
  background-color: var(--secondary);
}
.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}
.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: var(--accent);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: var(--accent-foreground);
}
.aria-selected\\:text-muted-foreground[aria-selected="true"] {
  color: hsla(202, 44%, 28%, 0.5);
  color: var(--muted-foreground);
}
.aria-selected\\:opacity-100[aria-selected="true"] {
  opacity: 1;
}
.aria-selected\\:opacity-30[aria-selected="true"] {
  opacity: 0.3;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side=bottom] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side=left] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side=right] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side=top] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-\\[19px\\][data-state=checked] {
  --tw-translate-x: 19px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-\\[2px\\][data-state=unchecked] {
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up {

  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state=closed] {
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down {

  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state=open] {
  animation: accordion-down 0.2s ease-out;
}
.data-\\[state\\=unchecked\\]\\:border-none[data-state=unchecked] {
  border-style: none;
}
.data-\\[active\\=true\\]\\:bg-\\[\\#1053FF\\][data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 83 255 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:bg-\\[\\#54C1FB\\][data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(84 193 251 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:bg-\\[\\#5ECA8F\\][data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(94 202 143 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:bg-\\[\\#F4855E\\][data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 133 94 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:bg-addition10[data-active=true] {
  background-color: var(--addition-10);
}
.data-\\[active\\=true\\]\\:bg-primary[data-active=true] {
  background-color: hsla(202, 44%, 28%, 1);
  background-color: var(--primary);
}
.data-\\[state\\=active\\]\\:bg-background[data-state=active] {
  background-color: hsla(220, 33%, 99%, 1);
  background-color: var(--background);
}
.data-\\[state\\=checked\\]\\:bg-addition6[data-state=checked] {
  background-color: hsla(184, 41%, 66%, 1);
  background-color: var(--addition-6);
}
.data-\\[state\\=checked\\]\\:bg-inputBg[data-state=checked] {
  background-color: hsla(202, 44%, 28%, 0.07);
  background-color: var(--input-bg);
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state=checked] {
  background-color: hsla(202, 44%, 28%, 1);
  background-color: var(--primary);
}
.data-\\[state\\=checked\\]\\:bg-secondary[data-state=checked] {
  background-color: hsla(351, 53%, 45%, 1);
  background-color: var(--secondary);
}
.data-\\[state\\=checked\\]\\:bg-white[data-state=checked] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state=open] {
  background-color: var(--accent);
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state=selected] {
  background-color: hsla(210, 16%, 89%, 1);
  background-color: var(--muted);
}
.data-\\[state\\=unchecked\\]\\:bg-primary[data-state=unchecked] {
  background-color: hsla(202, 44%, 28%, 1);
  background-color: var(--primary);
}
.data-\\[state\\=unchecked\\]\\:bg-white[data-state=unchecked] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:text-white[data-active=true] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state=active] {
  color: var(--foreground);
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state=checked] {
  color: #fff;
  color: var(--primary-foreground);
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state=open] {
  color: var(--accent-foreground);
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state=open] {
  color: hsla(202, 44%, 28%, 0.5);
  color: var(--muted-foreground);
}
.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}
.data-\\[state\\=checked\\]\\:opacity-100[data-state=checked] {
  opacity: 1;
}
.data-\\[state\\=active\\]\\:shadow-sm[data-state=active] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=unchecked\\]\\:shadow-none[data-state=unchecked] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=open\\]\\:animate-in[data-state=open] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state=closed] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state=closed] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state=open] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state=closed] {
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state=open] {
  --tw-enter-scale: .95;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side=bottom] {
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side=left] {
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side=right] {
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side=top] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state=closed] {
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state=closed] {
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state=open] {
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state=open] {
  --tw-enter-translate-y: -48%;
}
.child\\:m-0 > * {
  margin: 0px;
}
.child\\:mb-2 > * {
  margin-bottom: 0.5rem;
}
.child\\:mb-4 > * {
  margin-bottom: 1rem;
}
.child\\:flex > * {
  display: flex;
}
.child\\:h-full > * {
  height: 100%;
}
.child\\:max-h-\\[320px\\] > * {
  max-height: 320px;
}
.child\\:w-\\[100\\%\\] > * {
  width: 100%;
}
.child\\:flex-grow > * {
  flex-grow: 1;
}
.child\\:cursor-pointer > * {
  cursor: pointer;
}
.child\\:items-center > * {
  align-items: center;
}
.child\\:justify-start > * {
  justify-content: flex-start;
}
.child\\:justify-between > * {
  justify-content: space-between;
}
.child\\:overflow-y-auto > * {
  overflow-y: auto;
}
.child\\:rounded-none > * {
  border-radius: 0px;
}
.child\\:\\!border-0 > * {
  border-width: 0px !important;
}
.child\\:border > * {
  border-width: 1px;
}
.child\\:fill-white > * {
  fill: #fff;
}
.child\\:p-\\[10px_20px\\] > * {
  padding: 10px 20px;
}
.child\\:px-4 > * {
  padding-left: 1rem;
  padding-right: 1rem;
}
.child\\:py-2 > * {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.child\\:pr-0 > * {
  padding-right: 0px;
}
.child\\:text-\\[18px\\] > * {
  font-size: 18px;
}
.child\\:leading-tight > * {
  line-height: 1.25;
}
.child\\:text-\\[\\#02B3CB\\] > * {
  --tw-text-opacity: 1;
  color: rgb(2 179 203 / var(--tw-text-opacity));
}
.child\\:text-white > * {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.child\\:opacity-100 > * {
  opacity: 1;
}
.first\\:child\\:border-b > *:first-child {
  border-bottom-width: 1px;
}
.first\\:child\\:pl-\\[20px\\] > *:first-child {
  padding-left: 20px;
}
.last\\:child\\:mb-0 > *:last-child {
  margin-bottom: 0px;
}
.last\\:child\\:pr-\\[20px\\] > *:last-child {
  padding-right: 20px;
}
.hover\\:child\\:bg-muted > *:hover {
  background-color: hsla(210, 16%, 89%, 1);
  background-color: var(--muted);
}
.hover\\:child\\:bg-white > *:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.child-hover\\:text-addition1-60 > *:hover {
  color: color-mix(in srgb, hsla(238, 30%, 22%, 1) 60%, transparent);
  color: color-mix(in srgb, var(--addition-1) 60%, transparent);
}
.child-hover\\:text-addition1-70 > *:hover {
  color: color-mix(in srgb, hsla(238, 30%, 22%, 1) 70%, transparent);
  color: color-mix(in srgb, var(--addition-1) 70%, transparent);
}
@supports ((-webkit-backdrop-filter: var(--tw)) or (backdrop-filter: var(--tw))) {

  .supports-\\[backdrop-filter\\]\\:bg-\\[\\#2e446bcc\\]\\/50 {
    background-color: rgb(46 68 107 / 0.5);
  }
}
@media (min-width: 480px) {

  .xs\\:h-\\[32px\\] {
    height: 32px;
  }

  .xs\\:w-\\[170px\\] {
    width: 170px;
  }

  .xs\\:w-\\[300px\\] {
    width: 300px;
  }

  .xs\\:w-auto {
    width: auto;
  }

  .xs\\:flex-row {
    flex-direction: row;
  }
}
@media (min-width: 640px) {

  .sm\\:mb-9 {
    margin-bottom: 2.25rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:w-\\[250px\\] {
    width: 250px;
  }

  .sm\\:w-\\[450px\\] {
    width: 450px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[repeat\\(2\\2c auto\\)\\] {
    grid-template-columns: repeat(2,auto);
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-\\[20px\\] {
    gap: 20px;
  }

  .sm\\:gap-\\[40px\\] {
    gap: 40px;
  }

  .sm\\:gap-x-\\[20px\\] {
    -moz-column-gap: 20px;
         column-gap: 20px;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg {
    border-radius: 6px;
    border-radius: var(--radius);
  }

  .sm\\:bg-transparent {
    background-color: transparent;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-7 {
    padding: 1.75rem;
  }

  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:pl-\\[20px\\] {
    padding-left: 20px;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-xl {
    font-size: 24px;
    line-height: 32px;
  }

  .sm\\:backdrop-blur-none {
    --tw-backdrop-blur: blur(0);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
            backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  }
}
@media (min-width: 768px) {

  .md\\:relative {
    position: relative;
  }

  .md\\:sticky {
    position: -webkit-sticky;
    position: sticky;
  }

  .md\\:top-\\[unset\\] {
    top: auto;
    top: initial;
  }

  .md\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-20 {
    height: 5rem;
  }

  .md\\:h-\\[81vh\\] {
    height: 81vh;
  }

  .md\\:max-h-\\[calc\\(100vh-120px\\)\\] {
    max-height: calc(100vh - 120px);
  }

  .md\\:min-h-\\[81vh\\] {
    min-height: 81vh;
  }

  .md\\:w-\\[unset\\] {
    width: auto;
    width: initial;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[275px\\2c auto\\2c 1fr\\] {
    grid-template-columns: 275px auto 1fr;
  }

  .md\\:grid-cols-\\[320px\\2c 1fr\\] {
    grid-template-columns: 320px 1fr;
  }

  .md\\:grid-cols-\\[repeat\\(3\\2c auto\\)\\] {
    grid-template-columns: repeat(3,auto);
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-\\[20px\\] {
    gap: 20px;
  }

  .md\\:gap-\\[30px\\] {
    gap: 30px;
  }

  .md\\:gap-x-\\[30px\\] {
    -moz-column-gap: 30px;
         column-gap: 30px;
  }

  .md\\:gap-x-\\[40px\\] {
    -moz-column-gap: 40px;
         column-gap: 40px;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-\\[30px\\] {
    padding: 30px;
  }

  .md\\:px-\\[15px\\] {
    padding-left: 15px;
    padding-right: 15px;
  }

  .md\\:px-\\[70px\\] {
    padding-left: 70px;
    padding-right: 70px;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:pb-\\[40px\\] {
    padding-bottom: 40px;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }
}
@media (min-width: 1024px) {

  .lg\\:absolute {
    position: absolute;
  }

  .lg\\:relative {
    position: relative;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-\\[15px\\] {
    margin-bottom: 15px;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[660px\\] {
    height: 660px;
  }

  .lg\\:w-\\[215px\\] {
    width: 215px;
  }

  .lg\\:w-\\[calc\\(100\\%-470px\\)\\] {
    width: calc(100% - 470px);
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:translate-x-\\[0\\] {
    --tw-translate-x: 0;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[215px_1fr\\] {
    grid-template-columns: 215px 1fr;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:gap-0 {
    gap: 0px;
  }

  .lg\\:gap-\\[10px\\] {
    gap: 10px;
  }

  .lg\\:gap-\\[70px\\] {
    gap: 70px;
  }

  .lg\\:gap-x-\\[60px\\] {
    -moz-column-gap: 60px;
         column-gap: 60px;
  }

  .lg\\:gap-x-\\[70px\\] {
    -moz-column-gap: 70px;
         column-gap: 70px;
  }

  .lg\\:gap-y-\\[30px\\] {
    row-gap: 30px;
  }

  .lg\\:space-x-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--tw-space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:rounded-\\[10px\\] {
    border-radius: 10px;
  }

  .lg\\:py-\\[30px\\] {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .lg\\:transition-none {
    transition-property: none;
  }

  .lg\\:after\\:mx-\\[10px\\]::after {
    content: var(--tw-content);
    margin-left: 10px;
    margin-right: 10px;
  }

  .lg\\:after\\:h-\\[12px\\]::after {
    content: var(--tw-content);
    height: 12px;
  }

  .lg\\:after\\:w-\\[1px\\]::after {
    content: var(--tw-content);
    width: 1px;
  }

  .lg\\:after\\:bg-secondary-50::after {
    content: var(--tw-content);
    background-color: color-mix(in srgb, hsla(351, 53%, 45%, 1) 50%, transparent);
    background-color: color-mix(in srgb, var(--secondary) 50%, transparent);
  }
}
@media (min-width: 1280px) {

  .xl\\:mt-\\[0\\] {
    margin-top: 0;
  }

  .xl\\:min-w-\\[120px\\] {
    min-width: 120px;
  }

  .xl\\:grid-cols-\\[repeat\\(3\\2c minmax\\(auto\\2c 370px\\)\\)\\] {
    grid-template-columns: repeat(3,minmax(auto,370px));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:items-center {
    align-items: center;
  }

  .xl\\:gap-\\[30px\\] {
    gap: 30px;
  }

  .xl\\:gap-y-\\[30px\\] {
    row-gap: 30px;
  }

  .xl\\:px-\\[30px\\] {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (min-width: 1366px) {

  .xxl\\:block {
    display: block;
  }

  .xxl\\:hidden {
    display: none;
  }

  .xxl\\:h-\\[32px\\] {
    height: 32px;
  }

  .xxl\\:h-full {
    height: 100%;
  }

  .xxl\\:w-\\[1px\\] {
    width: 1px;
  }

  .xxl\\:w-\\[200px\\] {
    width: 200px;
  }

  .xxl\\:w-\\[38px\\] {
    width: 38px;
  }

  .xxl\\:grid-cols-\\[275px\\2c auto\\2c 1fr\\] {
    grid-template-columns: 275px auto 1fr;
  }

  .xxl\\:grid-cols-\\[repeat\\(3\\2c auto\\)\\] {
    grid-template-columns: repeat(3,auto);
  }

  .xxl\\:justify-end {
    justify-content: flex-end;
  }

  .xxl\\:justify-between {
    justify-content: space-between;
  }
}
@media (min-width: 1650px) {

  .min-\\[1650px\\]\\:object-cover {
    object-fit: cover;
  }
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end) {
  border-top-right-radius: calc(6px - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(6px - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start) {
  border-top-left-radius: calc(6px - 2px);
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(6px - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]) {
  border-radius: calc(6px - 2px);
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]) {
  background-color: var(--accent);
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
  border-top-left-radius: calc(6px - 2px);
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(6px - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
  border-top-right-radius: calc(6px - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(6px - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
  border-top-right-radius: calc(6px - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(6px - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox] {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\]\\:size-3\\.5>svg {
  width: 0.875rem;
  height: 0.875rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
  font-size: 12px;
  line-height: 18px;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  color: hsla(202, 44%, 28%, 0.5);
  color: var(--muted-foreground);
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
  width: 1.25rem;
}
.last\\:\\[\\&_a\\]\\:after\\:hidden a:last-child::after {
  content: var(--tw-content);
  display: none;
}
.\\[\\&_button\\]\\:w-\\[44px\\] button {
  width: 44px;
}
.\\[\\&_button\\]\\:border-\\[2px\\] button {
  border-width: 2px;
}
.\\[\\&_button\\]\\:border-white button {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.\\[\\&_button\\]\\:bg-transparent button {
  background-color: transparent;
}
.\\[\\&_button\\]\\:p-\\[10px\\] button {
  padding: 10px;
}
.\\[\\&_button\\]\\:text-white button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.\\[\\&_button\\]\\:hover\\:text-white:hover button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.\\[\\&_div\\]\\:opacity-70 div {
  opacity: 0.7;
}
.group:hover .group-hover\\:\\[\\&_div\\]\\:border-secondary div {
  border-color: hsla(351, 53%, 45%, 1);
  border-color: var(--secondary);
}
.group:hover .group-hover\\:\\[\\&_div\\]\\:bg-secondary div {
  background-color: hsla(351, 53%, 45%, 1);
  background-color: var(--secondary);
}
.\\[\\&_path\\]\\:\\!fill-\\[\\#54C1FB\\] path {
  fill: #54C1FB !important;
}
.\\[\\&_path\\]\\:\\!fill-primary path {
  fill: hsla(202, 44%, 28%, 1) !important;
  fill: var(--primary) !important;
}
.\\[\\&_path\\]\\:fill-\\[\\#c6cfdb\\] path {
  fill: #c6cfdb;
}
.\\[\\&_path\\]\\:fill-addition11-30 path {
  fill: color-mix(in srgb, var(--addition-11) 30%, transparent);
}
.\\[\\&_path\\]\\:fill-addition5 path {
  fill: hsla(184, 100%, 36%, 1);
  fill: var(--addition-5);
}
.\\[\\&_path\\]\\:fill-addition6 path {
  fill: hsla(184, 41%, 66%, 1);
  fill: var(--addition-6);
}
.\\[\\&_path\\]\\:fill-addition9 path {
  fill: var(--addition-9);
}
.\\[\\&_path\\]\\:fill-primary path {
  fill: hsla(202, 44%, 28%, 1);
  fill: var(--primary);
}
.\\[\\&_path\\]\\:fill-secondary2 path {
  fill: var(--secondary-2);
}
.\\[\\&_path\\]\\:fill-white path {
  fill: #fff;
}
.\\[\\&_path\\]\\:stroke-addition5 path {
  stroke: hsla(184, 100%, 36%, 1);
  stroke: var(--addition-5);
}
.\\[\\&_path\\]\\:opacity-50 path {
  opacity: 0.5;
}
.\\[\\&_path\\]\\:hover\\:fill-destructive:hover path {
  fill: #e0425b;
  fill: var(--destructive);
}
.group:hover .group-hover\\:\\[\\&_path\\]\\:fill-white path {
  fill: #fff;
}
.\\[\\&_rect\\]\\:fill-transparent rect {
  fill: transparent;
}
.\\[\\&_rect\\]\\:fill-white rect {
  fill: #fff;
}
.\\[\\&_rect\\]\\:stroke-addition5 rect {
  stroke: hsla(184, 100%, 36%, 1);
  stroke: var(--addition-5);
}
.\\[\\&_span\\]\\:px-2 span {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_span\\]\\:font-normal span {
  font-weight: 400;
}
.\\[\\&_span\\]\\:opacity-60 span {
  opacity: 0.6;
}
.\\[\\&_svg\\]\\:h-\\[18px\\] svg {
  height: 18px;
}
.\\[\\&_svg\\]\\:h-\\[20px\\] svg {
  height: 20px;
}
.\\[\\&_svg\\]\\:w-\\[18px\\] svg {
  width: 18px;
}
.\\[\\&_svg\\]\\:w-\\[20px\\] svg {
  width: 20px;
}
.\\[\\&_svg_path\\]\\:fill-\\[\\#6D71F8\\] svg path {
  fill: #6D71F8;
}
.\\[\\&_svg_path\\]\\:fill-current svg path {
  fill: currentColor;
}
.\\[\\&_svg_path\\]\\:fill-secondary-50 svg path {
  fill: color-mix(in srgb, hsla(351, 53%, 45%, 1) 50%, transparent);
  fill: color-mix(in srgb, var(--secondary) 50%, transparent);
}
.\\[\\&_svg_path\\]\\:fill-secondary-70 svg path {
  fill: color-mix(in srgb, hsla(351, 53%, 45%, 1) 70%, transparent);
  fill: color-mix(in srgb, var(--secondary) 70%, transparent);
}
.\\[\\&_svg_path\\]\\:fill-transparent svg path {
  fill: transparent;
}
.\\[\\&_svg_path\\]\\:fill-white svg path {
  fill: #fff;
}
.group:hover .group-hover\\:\\[\\&_svg_path\\]\\:fill-white svg path {
  fill: #fff;
}
.\\[\\&_td_a\\]\\:hover\\:bg-primary:hover td a {
  background-color: hsla(202, 44%, 28%, 1);
  background-color: var(--primary);
}
.\\[\\&_td_a\\]\\:hover\\:text-white:hover td a {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr {
  border-bottom-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/resource/font/stylesheet.scss"],"names":[],"mappings":"AAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;EAAA;IAAA,aAAA;IAAA,qBAAA;IAAA,uBAAA;IAAA,iCAAA;IAAA,8BAAA;IAAA,mCAAA;IAAA,0BAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,qCAAA;IAAA,qCAAA;IAAA,oCAAA;IAAA,aAAA;IAAA,kCAAA;IAAA,iCAAA;IAAA,+BAAA;IAAA,qCAAA;IAAA,6CAAA;IAAA,iCAAA;IAAA,+BAAA;IAAA,4CAAA;IAAA,sBAAA;IAAA,oBAAA;IAAA,gCAAA;IAAA,8BAAA;IAAA,mCAAA;IAAA,gCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,mCAAA;IAAA,8BAAA;IAAA,mCAAA;IAAA,+BAAA;IAAA,gCAAA;IAAA,kCAAA;IAAA,mCAAA;IAAA,oCAAA;IAAA,4BAAA;IAAA,2BAAA;IAAA,8BAAA;IAAA,qBAAA;IAAA,mCAAA;IAAA,4BAAA;IAAA,0CAAA;IAAA,qCAAA;IAAA,kCAAA;IAAA,+BAAA;IAAA,wCAAA;IAAA,2BAAA;IAAA,sCAAA;IAAA,4BAAA;IAAA,qCAAA;IAAA,0BAAA;IAAA,qCAAA;IAAA,0BAAA;IAAA,yBAAA;IAAA,wBAAA;IAAA,oBAAA;IAAA,6DAAA;EAAA;EAAA;IAAA,iCAAA;EAAA;EAAA;IAAA,aAAA;IAAA,iCAAA;IAAA,iCAAA;IAAA,mCAAA;IAAA,qCAAA;IAAA,6BAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,mCAAA;IAAA,oCAAA;IAAA,qCAAA;IAAA,oCAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,qCAAA;IAAA,kCAAA;IAAA,aAAA;IAAA,kCAAA;IAAA,iCAAA;IAAA,+BAAA;IAAA,qCAAA;IAAA,iCAAA;IAAA,+BAAA;IAAA,4CAAA;IAAA,sCAAA;IAAA,oCAAA;EAAA;EAAA;EAAA,sCAAA;EAAA;AAAA;EAAA;EAAA,wCAAA;EAAA,mCAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AACA;EAAA,WAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AACA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,SAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,aAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;KAAA,sBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;OAAA;AAAA;AAAA;EAAA,wBAAA;OAAA;AAAA;AAAA;EAAA,qBAAA;OAAA;AAAA;AAAA;EAAA,qBAAA;OAAA;AAAA;AAAA;EAAA,oBAAA;OAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,gEAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA,yCAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,qCAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qCAAA;EAAA;AAAA;AAAA;EAAA,qCAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,mDAAA;EAAA;AAAA;AAAA;EAAA,mDAAA;EAAA;AAAA;AAAA;EAAA,wFAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,8EAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA;AAAA;AAAA;EAAA,4EAAA;EAAA;AAAA;AAAA;EAAA,4EAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA;AAAA;AAAA;EAAA,4EAAA;EAAA;AAAA;AAAA;EAAA,4EAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA;AAAA;AAAA;EAAA,4EAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,yDAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iEAAA;EAAA;AAAA;AAAA;EAAA,iEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,4DAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA,0EAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA,+QAAA;UAAA;AAAA;AAAA;EAAA,+QAAA;UAAA;AAAA;AAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,UAAA;IAAA,mCAAA;IAAA,0DAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,UAAA;IAAA,kCAAA;IAAA,0DAAA;IAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;ACAA;EACI,sBAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADCJ;ACEA;EACI,sBAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADDJ;ACIA;EACI,sBAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;ADHJ;ACMA;EACI,sBAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;ADLJ;ACQA;EACI,sBAAA;EACA,qHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADPJ;ACUA;EACI,sBAAA;EACA,sHAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;ADTJ;ACaA;EACI,sBAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADZJ;AA2EA;EACE,QAAA;AAuBF;;AApBA;EACE,sBAAA;AAuBF;AAVA;;;EAGE,sBAAA;AAqBF;;AAlBA;;EAEE,UAAA;AAqBF;;AAlBA;;;;;;;;;;;;;;EAcE,SAAA;AAqBF;;AAlBA;EACE,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,2BAAA;AAqBF;;AAnBA;EACE,8BAAA;AAsBF;;AAnBA;;EAEE,gBAAA;AAsBF;;AAnBA;EACE,qBAAA;EACA,iCAAA;UAAA,8BAAA;AAsBF;;AAnBA;EACE,eAAA;EACA,cAAA;AAsBF;;AAnBA;;;;EAIE,aAAA;AAsBF;;AAnBA;EACE,0BAAA;AAsBF;;AAnBA;;EAEE,wBAAA;AAsBF;;AAnBA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AAsBF;;AAnBA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AAsBF;AApBE;EACE,iBAAA;EACA,yBAAA;AAsBJ;;AAlBA,mCAAA;AACA;EACE,kEACE;EAEF,uBAAA;EAEA,yBAAA;AAkBF;;AAfA;EACE,wBAAA;EAEA,YAAA;AAiBF;;AAbE;EACE,6BAAA;AAgBJ;;AAXE;EAAA;AAAA;;AAKA;;EACE,aAAA;AAcJ;;AARI;EACE,cAAA;AAWN;AAPE;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,WAAA;AASJ;;AAJE;EAkBE,WAAA;EACA,iBAAA;AAVJ;AAaE;EACE,yBAAA;AAXJ;AAcE;EAEE,sBAAA;EACA,aAAA;AAbJ;AAgBE;EACE,cAAA;AAdJ;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,eAqTA;EArTA;AAqTA;AArTA;EAAA,eAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,+BAqTA;EArTA;AAqTA;AArTA;EAAA,+BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA,+BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA,6EAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA,6BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA,gKAqTA;EArTA,wJAqTA;EArTA,iLAqTA;EArTA,wDAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,gBAqTA;EArTA;AAqTA;AArTA;EAAA,iBAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,2GAqTA;EArTA,yGAqTA;EArTA,0EAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,uBAqTA;EArTA;AAqTA;AArTA;EAAA,sBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,8EAqTA;EArTA;AAqTA;AArTA;EAAA,8EAqTA;EArTA;AAqTA;AArTA;EAAA,yCAqTA;EArTA;AAqTA;AArTA;EAAA,yBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,2CAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,6EAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,4EAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,iEAqTA;EArTA;AAqTA;AArTA;EAAA,4BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,6BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,cAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,+BAqTA;EArTA;AAqTA;AArTA;EAAA,6BAqTA;EArTA;AAqTA;AArTA;EAAA,WAqTA;EArTA;AAqTA;AArTA;EAAA,6BAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,0BAqTA;EArTA,qBAqTA;EArTA;AAqTA;AArTA;EAAA,oCAqTA;EArTA;AAqTA;AArTA;EAAA,mDAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,sBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,WAqTA;EArTA;AAqTA;AArTA;EAAA,8BAqTA;EArTA;AAqTA;AArTA;EAAA,2GAqTA;EArTA,yGAqTA;EArTA,0EAqTA;EArTA;AAqTA;AArTA;EAAA,2GAqTA;EArTA,yGAqTA;EArTA,0EAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,8BAqTA;EArTA;AAqTA;AArTA;EAAA,2GAqTA;EArTA,yGAqTA;EArTA,0EAqTA;EArTA;AAqTA;AArTA;EAAA,2GAqTA;EArTA,yGAqTA;EArTA,0EAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,6BAqTA;EArTA;AAqTA;AArTA;EAAA,6BAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,oCAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,+BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,yBAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,yBAqTA;EArTA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA,sBAqTA;EArTA;AAqTA;AArTA;EAAA,qBAqTA;EArTA;AAqTA;AArTA;;EAAA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;AAAA;AArTA;EAAA;AAqTA;AArTA;;EAAA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;AAAA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,2CAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,WAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,+BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,0CAqTA;EArTA,uDAqTA;EArTA,kDAqTA;EArTA;AAqTA;AArTA;EAAA,sBAqTA;EArTA,8BAqTA;EArTA,kDAqTA;EArTA;AAqTA;AArTA;EAAA,qBAqTA;EArTA,yBAqTA;EArTA,2BAqTA;EArTA,yBAqTA;EArTA,0BAqTA;EArTA,+BAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA,yBAqTA;EArTA,0BAqTA;EArTA,wBAqTA;EArTA,yBAqTA;EArTA,8BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,mBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,kBAqTA;EArTA;AAqTA;AArTA;EAAA,kEAqTA;EArTA;AAqTA;AArTA;EAAA,kEAqTA;EArTA;AAqTA;AArTA;;EAAA;IAAA;EAqTA;AAAA;AArTA;;EAAA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;AAAA;AArTA;;EAAA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,qBAqTA;SArTA;EAqTA;;EArTA;IAAA,uBAqTA;IArTA,sDAqTA;IArTA;EAqTA;;EArTA;IAAA,uBAqTA;IArTA,oDAqTA;IArTA;EAqTA;;EArTA;IAAA,uBAqTA;IArTA,2DAqTA;IArTA;EAqTA;;EArTA;IAAA,kBAqTA;IArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,qBAqTA;IArTA;EAqTA;;EArTA;IAAA,oBAqTA;IArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,eAqTA;IArTA;EAqTA;;EArTA;IAAA,2BAqTA;IArTA,+QAqTA;YArTA;EAqTA;AAAA;AArTA;;EAAA;IAAA;EAqTA;;EArTA;IAAA,wBAqTA;IArTA;EAqTA;;EArTA;IAAA,SAqTA;IArTA;EAqTA;;EArTA;IAAA,eAqTA;IArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,WAqTA;IArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,qBAqTA;SArTA;EAqTA;;EArTA;IAAA,qBAqTA;SArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,kBAqTA;IArTA;EAqTA;;EArTA;IAAA,kBAqTA;IArTA;EAqTA;;EArTA;IAAA,iBAqTA;IArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;AAAA;AArTA;;EAAA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,mBAqTA;IArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,qBAqTA;SArTA;EAqTA;;EArTA;IAAA,qBAqTA;SArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,uBAqTA;IArTA,sDAqTA;IArTA;EAqTA;;EArTA;IAAA,uBAqTA;IArTA,oDAqTA;IArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,iBAqTA;IArTA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,0BAqTA;IArTA,iBAqTA;IArTA;EAqTA;;EArTA;IAAA,0BAqTA;IArTA;EAqTA;;EArTA;IAAA,0BAqTA;IArTA;EAqTA;;EArTA;IAAA,0BAqTA;IArTA,6EAqTA;IArTA;EAqTA;AAAA;AArTA;;EAAA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA,kBAqTA;IArTA;EAqTA;AAAA;AArTA;;EAAA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;;EArTA;IAAA;EAqTA;AAAA;AArTA;;EAAA;IAAA;EAqTA;AAAA;AArTA;EAAA,wCAqTA;EArTA,kDAqTA;EArTA,2CAqTA;EArTA;AAqTA;AArTA;EAAA,uCAqTA;EArTA,iDAqTA;EArTA,0CAqTA;EArTA;AAqTA;AArTA;EAAA,8BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,uCAqTA;EArTA,iDAqTA;EArTA,0CAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA,kDAqTA;EArTA,2CAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA,kDAqTA;EArTA,2CAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,qBAqTA;EArTA;AAqTA;AArTA;EAAA,gBAqTA;EArTA,oBAqTA;EArTA,4BAqTA;EArTA;AAqTA;AArTA;EAAA,eAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,mBAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,qBAqTA;EArTA;AAqTA;AArTA;EAAA,eAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,+BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,0BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,sBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,oCAqTA;EArTA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,uCAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,6BAqTA;EArTA;AAqTA;AArTA;EAAA,4BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,4BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,+BAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,aAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,+BAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,iEAqTA;EArTA;AAqTA;AArTA;EAAA,iEAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA,wCAqTA;EArTA;AAqTA;AArTA;EAAA,oBAqTA;EArTA;AAqTA;AArTA;EAAA;AAqTA;AArTA;EAAA;AAqTA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import 'src/resource/font/stylesheet';\n\n@layer base {\n  :root {\n    --white: #fff;\n    --light-gray: #fbfbfd;\n    --light-gray-2: #f8f8f8;\n\n    --primary: hsla(202, 44%, 28%, 1); // #284f66\n    --primary-text: var(--primary);\n\n    --secondary: hsla(351, 53%, 45%, 1); // #af3649\n\n    --primary-foreground: #fff;\n\n    --addition-1: hsla(238, 30%, 22%, 1); // #272848\n    --addition-2: hsla(211, 67%, 42%, 1); // #2368b4\n    --addition-3: hsla(205, 58%, 44%, 1); // #307bb2\n    --addition-4: hsla(189, 100%, 41%, 1); // #00b1cf\n    --addition-5: hsla(184, 100%, 36%, 1); // #00ADB9\n    --addition-6: hsla(184, 41%, 66%, 1); // #86c7cc\n\n    --radius: 6px;\n    --border: hsla(202, 44%, 28%, 0.1);\n    --input: hsla(202, 44%, 28%, 0.1);\n    --ring: hsla(184, 100%, 36%, 1);\n\n    --input-bg: hsla(202, 44%, 28%, 0.07);\n    --secondary-button: hsla(202, 44%, 28%, 0.15);\n    --label: hsla(202, 44%, 28%, 0.7);\n\n    --muted: hsla(210, 16%, 89%, 1); // hsla(212, 39%, 52%, 0.18);\n    --muted-foreground: hsla(202, 44%, 28%, 0.5);\n    --destructive: #e0425b;\n\n    /** Status colors: */\n    --running: hsla(35, 82%, 51%, 1);\n    --done: hsla(169, 86%, 44%, 1);\n    --earlyDrop: hsla(202, 79%, 51%, 1); // #1D9DE5\n    --late: hsla(238, 30%, 22%, 0.6);\n    --pending: hsla(187, 62%, 47%, 1);\n    --approved: hsla(191, 57%, 51%, 1);\n    --scheduled: hsla(40, 100%, 50%, 1);\n    --sent: hsla(198, 62%, 47%, 1); // hsla(169, 86%, 44%, 1)\n    --completed: hsla(169, 86%, 44%, 1); // hsla(169, 86%, 44%, 1)\n    --draft: hsla(351, 72%, 57%, 1);\n    --active: hsla(169, 86%, 44%, 1); // hsla(169, 86%, 44%, 1)\n    --inactive: hsla(351, 72%, 57%, 1);\n    --delivered: hsla(202, 79%, 51%, 1); // #1D9DE5\n\n    //--transparent-white: #FFFFFF99; // white with 0.6 opacity\n\n    --background: hsla(220, 33%, 99%, 1);\n\n    /*--success: 144, 79%, 62%;*/\n    /*--background: 0 0% 100%;*/\n    /*--foreground: 240 10% 3.9%;*/\n    /*--card: 0 0% 100%;*/\n    /*--card-foreground: 240 10% 3.9%;*/\n    --popover: hsla(0, 0%, 100%);\n    --popover-foreground: hsla(240, 10%, 3.9%);\n    /*--primary: hsla(211, 67%, 42%, 1);*/\n    /*--primary-foreground: 0 0% 98%;*/\n    /*--secondary: 240 4.8% 95.9%;*/\n    /*--secondary-foreground: 240 5.9% 10%;*/\n    /*--muted: 240 4.8% 95.9%;*/\n    /*--muted-foreground: 240 3.8% 46.1%;*/\n    /*--accent: 240 4.8% 95.9%;*/\n    /*--accent-foreground: 240 5.9% 10%;*/\n    /*--destructive: #E74A4A;*/\n    /*--destructive-foreground: #e16363;*/\n    /*--border: 240 5.9% 90%;*/\n    /*--input: 240 5.9% 90%;*/\n    /*--ring: 240 5.9% 10%;*/\n    /*--radius: 0.3rem;*/\n\n    --font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  }\n\n  .home {\n    --primary: hsla(215, 33%, 35%, 1); // #3C5476\n  }\n\n  .guidance {\n    --white: #fff;\n\n    //--primary: hsla(237, 100%, 63%, 1); // #424BFF\n    --primary: hsla(201, 95%, 66%, 1); // #54C1FB\n    --primary-text: var(--addition-1);\n    --secondary: hsla(238, 30%, 22%, 1); // #272848\n    --secondary-2: hsla(215, 32%, 70%, 1); // #99AECA;\n\n    --primary-foreground: #f8f9fd; // background\n\n    --addition-1: hsla(238, 30%, 22%, 1); // #272848\n    --addition-2: hsla(215, 33%, 35%, 1); // #3C5476\n    --addition-3: hsla(243, 91%, 36%, 1); // #1108B2\n    --addition-4: hsla(53, 56%, 54%, 1); // #CBBB49\n    --addition-5: hsla(123, 38%, 45%, 1); // #479D4C\n    --addition-6: hsla(237, 100%, 63%, 1); // #424BFF\n    --addition-7: hsla(238, 91%, 70%, 1); // #6D72F8FF\n    --addition-8: hsla(0, 61%, 45%, 1); // #B92C2C\n    --addition-9: hsla(15, 100%, 67%, 1); // #FF8057\n    --addition-10: hsla(263, 86%, 65%, 1); // #965BF3\n    --addition-11: hsla(0, 0%, 13%, 1); // #202020\n\n    --radius: 6px;\n    --border: hsla(238, 30%, 22%, 0.1);\n    --input: hsla(202, 44%, 28%, 0.1);\n    --ring: hsla(184, 100%, 36%, 1); //00ABB8FF\n\n    --input-bg: hsla(202, 44%, 28%, 0.07);\n    --label: hsla(202, 44%, 28%, 0.7);\n\n    --muted: rgba(135, 148, 172, 1); // #8794AC;\n    --muted-foreground: hsla(202, 44%, 28%, 0.5);\n    --destructive: hsla(357, 100%, 66%, 1); //#FF505A\n\n    --background: hsla(220, 33%, 99%, 1);\n  }\n}\n\n::-webkit-scrollbar {\n  width: 0;\n}\n\n:root {\n  --placeholder: #63748b;\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n\n  body {\n    @apply bg-background text-foreground;\n  }\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nul[class],\nol[class] {\n  padding: 0;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nul[class],\nol[class],\nli,\nfigure,\nfigcaption,\nblockquote,\ndl,\ndd {\n  margin: 0;\n}\n\nbody {\n  min-height: 100vh;\n  scroll-behavior: smooth;\n  text-rendering: optimizeSpeed;\n  line-height: 1.5;\n  font-family: 'Arial', serif;\n}\nhtml body[data-page-scrollable][data-scroll-locked] {\n  padding-right: 15px !important;\n}\n\nul[class],\nol[class] {\n  list-style: none;\n}\n\na:not([class]) {\n  text-decoration: none;\n  text-decoration-skip-ink: auto;\n}\n\nimg {\n  max-width: 100%;\n  display: block;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: auto;\n  font-family: 'DM Sans';\n}\n\n#root {\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: relative;\n\n  > * {\n    max-width: 2560px;\n    box-shadow: 0 0 50px #eee;\n  }\n}\n\n/** Animation for plus-minus icon */\n.plus rect {\n  transition:\n    transform 250ms ease-in-out,\n    opacity 250ms ease-in-out;\n  transform: rotate(0deg);\n  //transform: scaleY(1);\n  transform-origin: 50% 50%;\n}\n\n.minus .vertical-line {\n  transform: rotate(90deg);\n  //transform: scaleY(0);\n  opacity: 0.5;\n}\n\n.logo {\n  path {\n    fill: revert-layer !important;\n  }\n}\n\n.rdp-vhidden {\n  @apply hidden;\n}\n\n.rdp-dropdown_month,\n.rdp-dropdown_year {\n  .text-sm {\n    display: none;\n  }\n}\n\nbody.overlay {\n  &.lightbox-open {\n    &:before {\n      display: block;\n    }\n  }\n\n  &:before {\n    content: '';\n    position: fixed;\n    top: 0;\n    display: none;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.8);\n    z-index: 99;\n  }\n}\n\n.html-email-content {\n  & *,\n  & p,\n  & h1,\n  & h2,\n  & h3,\n  & h4,\n  & h5,\n  & h6,\n  & strong,\n  & em,\n  & b,\n  & i,\n  & ul,\n  & ol,\n  & li,\n  & blockquote,\n  & pre,\n  & code {\n    all: revert;\n    line-height: 1.15;\n  }\n\n  & table {\n    border-collapse: collapse;\n  }\n\n  & th,\n  & td {\n    border: 1px solid #333;\n    padding: 10px;\n  }\n\n  a {\n    color: #4582ec;\n  }\n}\n","// generate by https://transfonter.org/\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('DMSans-Black.woff2') format('woff2'),\n        url('DMSans-Black.woff') format('woff');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('DMSans-Light.woff2') format('woff2'),\n        url('DMSans-Light.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('DMSans-Italic.woff2') format('woff2'),\n        url('DMSans-Italic.woff') format('woff');\n    font-weight: normal;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('DMSans-Regular.woff2') format('woff2'),\n        url('DMSans-Regular.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('DMSans-SemiBold.woff2') format('woff2'),\n        url('DMSans-SemiBold.woff') format('woff');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('DMSans-Bold.woff2') format('woff2'),\n        url('DMSans-Bold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('DMSans-Medium.woff2') format('woff2'),\n        url('DMSans-Medium.woff') format('woff');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
